// src/screens/ResultsScreen.js - VERSÃO COMPLETA MELHORADA
import React, { useState, useEffect, useCallback } from 'react';
import {
  View,
  ScrollView,
  Modal,
  TouchableOpacity,
  Alert,
  RefreshControl,
  Platform,
  Linking,
} from 'react-native';
import {
  Appbar,
  Card,
  Title,
  Paragraph,
  Button,
  Text,
  Chip,
  Badge,
  IconButton,
  Divider,
  ActivityIndicator,
  ProgressBar,
  Tab,
  TabView,
  List,
  DataTable,
  Searchbar,
  FAB,
  Menu,
  Checkbox,
} from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { AVAQualisTheme } from '../theme/theme';
import { styles } from './ResultsScreen.css';
import * as api from '../lib/api';
import { AVALIADORES, getUnidadeHierarchy } from '../data/EstruturaOrganizacional';
import AttachmentComponent from '../components/AttachmentComponent';
import * as XLSX from 'xlsx';
import * as FileSystem from 'expo-file-system';
import * as Sharing from 'expo-sharing';
import AuthService from '../services/authService';

// Função para obter emoji do tipo de arquivo (igual ao AttachmentComponent)
const getFileEmoji = (mimeType, fileName) => {
  if (!mimeType && !fileName) return '📎';

  const type = mimeType?.toLowerCase() || fileName?.toLowerCase() || '';

  if (type.includes('pdf')) return '📄';
  if (type.includes('doc') || type.includes('word')) return '📝';
  if (type.includes('sheet') || type.includes('excel') || type.includes('csv')) return '📊';
  if (type.includes('zip') || type.includes('rar') || type.includes('7z')) return '🗜️';
  if (
    type.includes('image') ||
    type.includes('jpg') ||
    type.includes('png') ||
    type.includes('gif')
  )
    return '🖼️';
  if (type.includes('video') || type.includes('mp4') || type.includes('avi')) return '🎥';
  if (type.includes('audio') || type.includes('mp3') || type.includes('wav')) return '🎵';
  if (type.includes('text') || type.includes('txt')) return '📃';
  if (type.includes('presentation') || type.includes('ppt')) return '📽️';

  return '📎';
};

// Função corrigida para formatar data DD/MM/YYYY
const formatDate = dateString => {
  if (!dateString) return '';

  try {
    // Se já for uma string no formato DD/MM/YYYY, retorna como está
    if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }

    // Se for uma data ISO ou timestamp, converte
    const date = new Date(dateString);

    // Verifica se é uma data válida
    if (isNaN(date.getTime())) {
      console.warn('❌ Data inválida:', dateString);
      return dateString; // Retorna a string original se não conseguir converter
    }

    // Formata no padrão brasileiro
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('❌ Erro ao formatar data:', error, dateString);
    return dateString; // Retorna a string original em caso de erro
  }
};

// Função para verificar se a data está vencida
const isExpired = dateString => {
  if (!dateString) return false;

  try {
    let date;

    // Se estiver no formato DD/MM/YYYY
    if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('/').map(Number);
      date = new Date(year, month - 1, day);
    } else {
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  } catch (error) {
    console.error('❌ Erro ao verificar expiração:', error);
    return false;
  }
};

// Função para verificar se a data está próxima do vencimento (30 dias)
const isNearExpiry = dateString => {
  if (!dateString) return false;

  try {
    let date;

    // Se estiver no formato DD/MM/YYYY
    if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('/').map(Number);
      date = new Date(year, month - 1, day);
    } else {
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) {
      return false;
    }

    const today = new Date();
    const diffTime = date - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 30 && diffDays >= 0;
  } catch (error) {
    console.error('❌ Erro ao verificar proximidade de expiração:', error);
    return false;
  }
};

// Função para abrir anexo
// Função para abrir anexo - CORRIGIDA PARA LIDAR COM BASE64
const handleOpenAttachment = attachment => {
  if (!attachment) return;

  try {
    // Priorizar URL do Supabase se disponível
    let url = attachment.supabaseUrl || attachment.url || attachment.uri;

    if (!url) {
      Alert.alert('⚠️ Anexo Indisponível', 'Este anexo não pode ser visualizado.');
      return;
    }

    // Verificar se é um link externo (não base64)
    if (
      attachment.type === 'link' ||
      ((url.startsWith('http://') || url.startsWith('https://')) && !url.includes('data:'))
    ) {
      // É um link normal, abrir diretamente
      if (Platform.OS === 'web') {
        window.open(url, '_blank');
      } else {
        Linking.openURL(url).catch(error => {
          console.error('Erro ao abrir link:', error);
          Alert.alert('❌ Erro', 'Não foi possível abrir o link.');
        });
      }
      return;
    }

    // Se for uma URL base64 (data:...)
    if (url.startsWith('data:')) {
      if (Platform.OS === 'web') {
        // Para web, criar um blob e abrir em nova aba
        try {
          // Extrair o tipo MIME e os dados base64
          const [header, base64Data] = url.split(',');
          const mimeMatch = header.match(/data:([^;]+)/);
          const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';

          // Decodificar base64
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Criar blob
          const blob = new Blob([byteArray], { type: mimeType });

          // Criar URL temporária
          const blobUrl = URL.createObjectURL(blob);

          // Abrir em nova aba
          const newWindow = window.open(blobUrl, '_blank');

          // Limpar a URL após alguns segundos
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 60000); // 60 segundos

          // Se for PDF e a janela foi aberta, definir o título
          if (newWindow && mimeType === 'application/pdf' && attachment.name) {
            newWindow.document.title = attachment.name;
          }
        } catch (error) {
          console.error('Erro ao processar arquivo base64:', error);

          // Fallback: tentar abrir diretamente (funciona para alguns navegadores)
          const newWindow = window.open();
          if (newWindow) {
            newWindow.document.write(`
              <html>
                <head>
                  <title>${attachment.name || 'Anexo'}</title>
                  <style>
                    body { 
                      margin: 0; 
                      padding: 0; 
                      display: flex; 
                      justify-content: center; 
                      align-items: center; 
                      min-height: 100vh; 
                      background: #f0f0f0; 
                    }
                    img { 
                      max-width: 100%; 
                      max-height: 100vh; 
                      object-fit: contain; 
                    }
                    embed, iframe { 
                      width: 100vw; 
                      height: 100vh; 
                      border: none; 
                    }
                    .error { 
                      font-family: Arial, sans-serif; 
                      text-align: center; 
                      padding: 20px; 
                    }
                  </style>
                </head>
                <body>
            `);

            if (attachment.mimeType?.includes('image')) {
              newWindow.document.write(`<img src="${url}" alt="${attachment.name || 'Imagem'}" />`);
            } else if (attachment.mimeType === 'application/pdf') {
              newWindow.document.write(`<embed src="${url}" type="application/pdf" />`);
            } else {
              newWindow.document.write(`
                <div class="error">
                  <h2>Visualização não disponível</h2>
                  <p>Tipo de arquivo: ${attachment.mimeType || 'Desconhecido'}</p>
                  <p>Nome: ${attachment.name || 'Sem nome'}</p>
                  <a href="${url}" download="${attachment.name || 'download'}">Baixar arquivo</a>
                </div>
              `);
            }

            newWindow.document.write('</body></html>');
            newWindow.document.close();
          }
        }
      } else {
        // Para mobile, mostrar alerta informativo
        Alert.alert(
          '📎 Anexo Local',
          `Este anexo (${attachment.name || 'Sem nome'}) está armazenado localmente no dispositivo e não pode ser visualizado diretamente.\n\nTipo: ${attachment.mimeType || 'Desconhecido'}\nTamanho: ${attachment.size ? `${(attachment.size / 1024).toFixed(2)} KB` : 'Desconhecido'}`,
          [{ text: 'OK', style: 'default' }]
        );
      }
    } else {
      // URL normal (não base64), abrir normalmente
      if (Platform.OS === 'web') {
        window.open(url, '_blank');
      } else {
        Linking.openURL(url).catch(error => {
          console.error('Erro ao abrir anexo:', error);
          Alert.alert('❌ Erro', 'Não foi possível abrir o anexo.');
        });
      }
    }
  } catch (error) {
    console.error('Erro ao abrir anexo:', error);
    Alert.alert('❌ Erro', 'Não foi possível abrir o anexo.');
  }
};
// Componente Dialog Personalizado (MELHORADO COM ESTILOS DE BOTÕES)
const CustomDialog = ({ visible, onDismiss, title, message, actions, children }) => {
  return (
    <Modal visible={visible} transparent={true} animationType="fade" onRequestClose={onDismiss}>
      <TouchableOpacity style={styles.modalOverlay} activeOpacity={1} onPress={onDismiss}>
        <TouchableOpacity style={styles.dialogContainer} activeOpacity={1} onPress={() => {}}>
          <View style={styles.dialogHeader}>
            <Text style={styles.dialogTitle}>{title}</Text>
          </View>

          <View style={styles.dialogContent}>
            {children || <Text style={styles.dialogMessage}>{message}</Text>}
          </View>

          <View style={styles.dialogActions}>
            {actions.map((action, index) => (
              <TouchableOpacity
                key={index}
                style={[
                  styles.dialogButton,
                  index === actions.length - 1
                    ? styles.dialogButtonPrimary
                    : styles.dialogButtonSecondary,
                ]}
                onPress={() => {
                  action.action();
                  onDismiss();
                }}
              >
                <Text
                  style={[
                    styles.dialogButtonText,
                    index === actions.length - 1
                      ? styles.dialogButtonTextPrimary
                      : styles.dialogButtonTextSecondary,
                  ]}
                >
                  {action.text}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};
// Componente para Badge de Validação
const ValidationBadge = ({ validationInfo }) => {
  if (!validationInfo) return null;
  
  return (
    <View style={styles.validationBadgeContainer}>
      <View style={styles.validationBadge}>
        <MaterialCommunityIcons name="check-decagram" size={20} color="#4CAF50" />
        <Text style={styles.validationBadgeText}>Validado</Text>
      </View>
      <Text style={styles.validationInfo}>
        Por: {validationInfo.validadoPor}
      </Text>
      <Text style={styles.validationDate}>
        Em: {formatDate(validationInfo.dataValidacao)}
      </Text>
    </View>
  );
};
// COMPONENTE MELHORADO: Modal para confirmação de exclusão de formulário completo
const DeleteFormModal = ({ visible, onDismiss, form, onConfirm }) => {
  if (!visible || !form) return null;

  return (
    <Modal visible={visible} transparent={true} animationType="fade" onRequestClose={onDismiss}>
      <TouchableOpacity style={styles.modalOverlay} activeOpacity={1} onPress={onDismiss}>
        <TouchableOpacity style={styles.deleteModalContainer} activeOpacity={1} onPress={() => {}}>
          <View style={styles.deleteModalHeader}>
            <Text style={styles.deleteModalTitle}>🗑️ Excluir Formulário Completo</Text>
            <IconButton
              icon="close"
              size={24}
              onPress={onDismiss}
              iconColor={AVAQualisTheme.colors.error}
              style={styles.deleteModalCloseButton}
            />
          </View>

          <View style={styles.deleteModalContent}>
            <View style={styles.deleteModalWarningBox}>
              <MaterialCommunityIcons name="alert-circle" size={48} color="#D32F2F" />
              <Text style={styles.deleteModalWarningText}>ATENÇÃO: AÇÃO IRREVERSÍVEL!</Text>
            </View>

            <Text style={styles.deleteModalMessage}>Esta ação irá excluir PERMANENTEMENTE:</Text>

            <View style={styles.deleteModalList}>
              <View style={styles.deleteModalListItem}>
                <MaterialCommunityIcons name="file-document" size={20} color="#D32F2F" />
                <Text style={styles.deleteModalListText}>O formulário "{form.title}"</Text>
              </View>

              <View style={styles.deleteModalListItem}>
                <MaterialCommunityIcons name="comment-multiple" size={20} color="#D32F2F" />
                <Text style={styles.deleteModalListText}>TODAS as respostas relacionadas</Text>
              </View>

              <View style={styles.deleteModalListItem}>
                <MaterialCommunityIcons name="attachment" size={20} color="#D32F2F" />
                <Text style={styles.deleteModalListText}>TODOS os anexos e dados associados</Text>
              </View>
            </View>

            <Text style={styles.deleteModalFinalWarning}>Esta ação NÃO PODE SER DESFEITA!</Text>
          </View>

          <View style={styles.deleteModalActions}>
            <TouchableOpacity
              style={styles.deleteModalButtonCancel}
              onPress={() => {
                onDismiss();
                // Quando cancelar, voltar para o modal de opções
              }}
            >
              <Text style={styles.deleteModalButtonCancelText}>❌ Cancelar</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.deleteModalButtonConfirm}
              onPress={() => {
                onConfirm();
                // NÃO chamar onDismiss aqui - deixar o onConfirm cuidar disso
              }}
            >
              <Text style={styles.deleteModalButtonConfirmText}>🗑️ SIM, EXCLUIR TUDO</Text>
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

// NOVO COMPONENTE: Modal para confirmação de exclusão de respostas do avaliador
const DeleteEvaluatorModal = ({ visible, onDismiss, form, evaluator, onConfirm }) => {
  if (!visible || !form || !evaluator) return null;

  return (
    <Modal visible={visible} transparent={true} animationType="fade" onRequestClose={onDismiss}>
      <TouchableOpacity style={styles.modalOverlay} activeOpacity={1} onPress={onDismiss}>
        <TouchableOpacity style={styles.deleteModalContainer} activeOpacity={1} onPress={() => {}}>
          <View style={styles.deleteModalHeader}>
            <Text style={styles.deleteModalTitle}>🗑️ Excluir Respostas do Avaliador</Text>
            <IconButton
              icon="close"
              size={24}
              onPress={onDismiss}
              iconColor={AVAQualisTheme.colors.error}
              style={styles.deleteModalCloseButton}
            />
          </View>

          <View style={styles.deleteModalContent}>
            <View style={styles.deleteModalWarningBox}>
              <MaterialCommunityIcons name="account-remove" size={48} color="#FF9800" />
              <Text style={styles.deleteModalWarningText}>ATENÇÃO: AÇÃO IRREVERSÍVEL!</Text>
            </View>

            <Text style={styles.deleteModalMessage}>Esta ação irá excluir PERMANENTEMENTE:</Text>

            <View style={styles.deleteModalList}>
              <View style={styles.deleteModalListItem}>
                <MaterialCommunityIcons name="account" size={20} color="#FF9800" />
                <Text style={styles.deleteModalListText}>
                  Todas as respostas de {evaluator.nome}
                </Text>
              </View>

              <View style={styles.deleteModalListItem}>
                <MaterialCommunityIcons name="file-document" size={20} color="#FF9800" />
                <Text style={styles.deleteModalListText}>Para o formulário "{form.title}"</Text>
              </View>

              <View style={styles.deleteModalListItem}>
                <MaterialCommunityIcons name="attachment" size={20} color="#FF9800" />
                <Text style={styles.deleteModalListText}>
                  Incluindo anexos e achados registrados
                </Text>
              </View>
            </View>

            <Text style={styles.deleteModalFinalWarning}>Esta ação NÃO PODE SER DESFEITA!</Text>
          </View>

          <View style={styles.deleteModalActions}>
            <TouchableOpacity style={styles.deleteModalButtonCancel} onPress={onDismiss}>
              <Text style={styles.deleteModalButtonCancelText}>❌ Cancelar</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.deleteModalButtonConfirm}
              onPress={() => {
                onConfirm();
              }}
            >
              <Text style={styles.deleteModalButtonConfirmText}>🗑️ SIM, EXCLUIR RESPOSTAS</Text>
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

// COMPONENTE MELHORADO: Modal para seleção de exclusão específica
// COMPONENTE MELHORADO: Modal para seleção de exclusão específica
const DeleteOptionsModal = ({
  visible,
  onDismiss,
  form,
  responses,
  onDeleteForm,
  onDeleteEvaluator,
}) => {
  console.log('🔷 DeleteOptionsModal render:', {
    visible,
    hasForm: !!form,
    hasOnDeleteEvaluator: !!onDeleteEvaluator,
    evaluatorsCount: responses?.filter(r => r.avaliador && r.avaliador.id).length || 0,
  });

  if (!visible || !form) return null;
  // Obter avaliadores únicos que têm respostas
  const evaluatorsWithResponses = responses
    .filter(r => r.avaliador && r.avaliador.id)
    .reduce((acc, r) => {
      if (!acc.find(e => e.id === r.avaliador.id)) {
        acc.push(r.avaliador);
      }
      return acc;
    }, []);

  return (
    <Modal visible={visible} transparent={true} animationType="slide" onRequestClose={onDismiss}>
      <TouchableOpacity style={styles.modalOverlay} activeOpacity={1} onPress={onDismiss}>
        <TouchableOpacity
          style={[styles.deleteOptionsContainer, { maxHeight: '80%' }]}
          activeOpacity={1}
          onPress={() => {}}
        >
          <View style={styles.deleteOptionsHeader}>
            <Text style={styles.deleteOptionsTitle}>🗑️ Opções de Exclusão</Text>
            <IconButton
              icon="close"
              size={24}
              onPress={onDismiss}
              iconColor={AVAQualisTheme.colors.error}
              style={styles.deleteOptionsCloseButton}
            />
          </View>

          <ScrollView style={styles.deleteOptionsContent}>
            <Text style={styles.deleteOptionsSubtitle}>
              Escolha o que deseja excluir do formulário "{form.title}":
            </Text>

            {/* Opção: Excluir formulário completo */}
            <TouchableOpacity
              style={styles.deleteOptionCard}
              onPress={() => {
                onDeleteForm(); // REMOVIDO o onDismiss()
              }}
            >
              <View style={styles.deleteOptionIcon}>
                <MaterialCommunityIcons name="delete-forever" size={32} color="#D32F2F" />
              </View>
              <View style={styles.deleteOptionContent}>
                <Text style={styles.deleteOptionTitle}>Excluir Formulário Completo</Text>
                <Text style={styles.deleteOptionDescription}>
                  Remove o formulário e TODAS as respostas de todos os avaliadores permanentemente
                </Text>
              </View>
              <MaterialCommunityIcons name="chevron-right" size={24} color="#999" />
            </TouchableOpacity>

            <Divider style={styles.deleteOptionsDivider} />

            {/* Opções: Excluir por avaliador */}
            <Text style={styles.deleteOptionsSectionTitle}>
              Ou excluir respostas de avaliador específico:
            </Text>

            {evaluatorsWithResponses.map(evaluator => (
              <TouchableOpacity
                key={evaluator.id}
                style={styles.deleteOptionCard}
                onPress={() => {
                  console.log('🔵 TouchableOpacity clicado para avaliador:', evaluator.nome);
                  console.log('🔵 onDeleteEvaluator existe?', !!onDeleteEvaluator);
                  console.log('🔵 Tipo de onDeleteEvaluator:', typeof onDeleteEvaluator);

                  if (onDeleteEvaluator) {
                    console.log('🔵 Chamando onDeleteEvaluator...');
                    onDeleteEvaluator(evaluator);
                  } else {
                    console.error('❌ onDeleteEvaluator não está definido!');
                  }
                }}
              >
                <View style={styles.deleteOptionIcon}>
                  <MaterialCommunityIcons name="account-remove" size={28} color="#FF9800" />
                </View>
                <View style={styles.deleteOptionContent}>
                  <Text style={styles.deleteOptionTitle}>{evaluator.nome}</Text>
                  <Text style={styles.deleteOptionDescription}>
                    Remove apenas as respostas deste avaliador
                  </Text>
                  <Text style={styles.deleteOptionEmail}>
                    📧 {evaluator.login || evaluator.email}
                  </Text>
                </View>
                <MaterialCommunityIcons name="chevron-right" size={24} color="#999" />
              </TouchableOpacity>
            ))}

            {evaluatorsWithResponses.length === 0 && (
              <View style={styles.noEvaluatorsContainer}>
                <MaterialCommunityIcons name="information-outline" size={48} color="#999" />
                <Text style={styles.noEvaluatorsText}>
                  Não há respostas de avaliadores para excluir
                </Text>
              </View>
            )}
          </ScrollView>

          <View style={styles.deleteOptionsFooter}>
            <TouchableOpacity style={styles.deleteOptionsButtonCancel} onPress={onDismiss}>
              <Text style={styles.deleteOptionsButtonCancelText}>Cancelar</Text>
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

// NOVO COMPONENTE: Modal para visualizar respostas de avaliadores não designados
const UnauthorizedEvaluatorModal = ({ visible, onDismiss, evaluator, responses, form }) => {
  if (!visible || !evaluator || !responses || responses.length === 0) return null;

  // Buscar resposta do avaliador específico
  const evaluatorResponse = responses.find(r => r.avaliador?.id === evaluator.id);
  if (!evaluatorResponse) return null;

  return (
    <Modal visible={visible} transparent={true} animationType="slide" onRequestClose={onDismiss}>
      <View style={styles.unauthorizedModalOverlay}>
        <View style={styles.unauthorizedModalContainer}>
          <View style={styles.unauthorizedModalHeader}>
            <Text style={styles.unauthorizedModalTitle}>Respostas de Avaliador Não Designado</Text>
            <IconButton
              icon="close"
              size={24}
              onPress={onDismiss}
              iconColor={AVAQualisTheme.colors.error}
            />
          </View>

          <ScrollView style={styles.unauthorizedModalContent}>
            {/* Informações do Avaliador */}
            <Card style={styles.unauthorizedEvaluatorCard}>
              <Card.Content>
                <Text style={styles.unauthorizedEvaluatorName}>{evaluator.nome}</Text>
                <Text style={styles.unauthorizedEvaluatorInfo}>
                  Email: {evaluator.email || evaluator.login}
                </Text>
                <Text style={styles.unauthorizedEvaluatorInfo}>Nível: {evaluator.level}</Text>
                <Badge style={styles.unauthorizedBadge}>
                  ⚠️ Não designado para este formulário
                </Badge>
              </Card.Content>
            </Card>

            {/* Estatísticas das Respostas */}
            <Card style={styles.unauthorizedStatsCard}>
              <Card.Content>
                <Title style={styles.unauthorizedStatsTitle}>Resumo das Respostas</Title>
                <View style={styles.unauthorizedStatsGrid}>
                  <View style={styles.unauthorizedStatItem}>
                    <Text style={styles.unauthorizedStatValue}>
                      {Object.keys(evaluatorResponse.answers || {}).length}
                    </Text>
                    <Text style={styles.unauthorizedStatLabel}>Total Respondidas</Text>
                  </View>
                  <View style={styles.unauthorizedStatItem}>
                    <Text style={styles.unauthorizedStatValue}>
                      {new Date(
                        evaluatorResponse.lastModified || evaluatorResponse.createdAt
                      ).toLocaleDateString('pt-BR')}
                    </Text>
                    <Text style={styles.unauthorizedStatLabel}>Data</Text>
                  </View>
                </View>
              </Card.Content>
            </Card>

            {/* Lista de Respostas */}
            <Card style={styles.unauthorizedResponsesCard}>
              <Card.Content>
                <Title style={styles.unauthorizedResponsesTitle}>Respostas Detalhadas</Title>
                {form.requirements &&
                  form.requirements.map(requirement => {
                    const answer =
                      evaluatorResponse.answers?.[requirement.id] ||
                      evaluatorResponse.answers?.[requirement.codigo];
                    const finding =
                      evaluatorResponse.findings?.[requirement.id] ||
                      evaluatorResponse.findings?.[requirement.codigo];
                    const attachments =
                      evaluatorResponse.attachments?.[requirement.id] ||
                      evaluatorResponse.attachments?.[requirement.codigo] ||
                      [];

                    if (!answer) return null;

                    return (
                      <View key={requirement.id} style={styles.unauthorizedResponseItem}>
                        <View style={styles.unauthorizedResponseHeader}>
                          <Chip mode="outlined" compact>
                            {requirement.codigo}
                          </Chip>
                          {requirement.isEssential && (
                            <Badge style={styles.essentialBadge}>RE</Badge>
                          )}
                        </View>

                        <Text style={styles.unauthorizedResponseQuestion}>
                          {requirement.question}
                        </Text>

                        <View style={styles.unauthorizedResponseAnswer}>
                          <Text style={styles.unauthorizedResponseAnswerLabel}>
                            Resposta: {getAnswerLabel(answer)}
                          </Text>
                        </View>

                        {finding && (
                          <View style={styles.unauthorizedResponseFinding}>
                            <Text style={styles.unauthorizedResponseFindingLabel}>Achados:</Text>
                            <Text style={styles.unauthorizedResponseFindingText}>{finding}</Text>
                          </View>
                        )}

                        {attachments.length > 0 && (
                          <View style={styles.unauthorizedResponseAttachments}>
                            <Text style={styles.unauthorizedResponseAttachmentsLabel}>
                              📎 Anexos ({attachments.length}):
                            </Text>
                            {attachments.map((attachment, idx) => (
                              <TouchableOpacity
                                key={idx}
                                style={styles.unauthorizedAttachmentItem}
                                onPress={() => handleOpenAttachment(attachment)}
                              >
                                <Text style={styles.unauthorizedAttachmentIcon}>
                                  {getFileEmoji(attachment.mimeType, attachment.name)}
                                </Text>
                                <View style={styles.unauthorizedAttachmentInfo}>
                                  <Text style={styles.unauthorizedAttachmentName}>
                                    {attachment.name || 'Anexo'}
                                  </Text>
                                  {attachment.description && (
                                    <Text style={styles.unauthorizedAttachmentDescription}>
                                      {attachment.description}
                                    </Text>
                                  )}
                                  {attachment.validityDate && (
                                    <Text
                                      style={[
                                        styles.unauthorizedAttachmentValidity,
                                        isExpired(attachment.validityDate) &&
                                          styles.attachmentValidityExpired,
                                        isNearExpiry(attachment.validityDate) &&
                                          styles.attachmentValidityWarning,
                                      ]}
                                    >
                                      📅 Válido até: {formatDate(attachment.validityDate)}
                                      {isExpired(attachment.validityDate) && ' (VENCIDO)'}
                                      {isNearExpiry(attachment.validityDate) &&
                                        !isExpired(attachment.validityDate) &&
                                        ' (PRÓXIMO DO VENCIMENTO)'}
                                    </Text>
                                  )}
                                </View>
                                <MaterialCommunityIcons name="open-in-new" size={18} color="#666" />
                              </TouchableOpacity>
                            ))}
                          </View>
                        )}
                      </View>
                    );
                  })}
              </Card.Content>
            </Card>
          </ScrollView>

          <View style={styles.unauthorizedModalFooter}>
            <Button
              mode="contained"
              onPress={onDismiss}
              style={styles.unauthorizedModalCloseButton}
            >
              Fechar
            </Button>
          </View>
        </View>
      </View>
    </Modal>
  );
};

// Função auxiliar para obter label da resposta
const getAnswerLabel = answer => {
  switch (answer) {
    case 'conforme':
      return '✅ Conforme';
    case 'nao-conforme':
      return '❌ Não Conforme';
    case 'nao-se-aplica':
      return '➖ Não se Aplica';
    default:
      return answer || '⏳ Não Respondido';
  }
};

// CORRIGIDO: Componente para exibir progresso de cada avaliador (SEM LIXEIRA DUPLICADA)
const EvaluatorProgress = ({
  formId,
  formTitle,
  evaluators,
  responses,
  metadata,
  onDeleteResponse,
}) => {
  // Garantir que temos exatamente 2 avaliadores (designados no metadata)
  const designatedEvaluators = [
    metadata?.avaliador1 ? AVALIADORES.find(a => a.id === metadata.avaliador1) : null,
    metadata?.avaliador2 ? AVALIADORES.find(a => a.id === metadata.avaliador2) : null,
  ].filter(Boolean);

  // Se não há avaliadores no metadata, usar os primeiros 2 da lista geral
  if (designatedEvaluators.length === 0) {
    designatedEvaluators.push(...AVALIADORES.slice(0, 2));
  } else if (designatedEvaluators.length === 1) {
    // Se só tem 1, adicionar mais um
    const otherAvaliador = AVALIADORES.find(a => a.id !== designatedEvaluators[0].id);
    if (otherAvaliador) designatedEvaluators.push(otherAvaliador);
  }

  const getEvaluatorProgress = evaluator => {
    if (!evaluator || !evaluator.id)
      return {
        progress: 0,
        status: 'não iniciado',
        hasResponse: false,
        answeredQuestions: 0,
        responseId: null,
      };

    const evaluatorResponse = responses.find(r => r.avaliador?.id === evaluator.id);

    if (!evaluatorResponse) {
      return {
        progress: 0,
        status: 'não iniciado',
        hasResponse: false,
        answeredQuestions: 0,
        responseId: null,
      };
    }

    const totalQuestions = evaluatorResponse.totalQuestions || 1;
    const answeredQuestions = Object.keys(evaluatorResponse.answers || {}).length;
    const progress = totalQuestions > 0 ? answeredQuestions / totalQuestions : 0;

    if (progress === 0)
      return {
        progress: 0,
        status: 'não iniciado',
        hasResponse: true,
        answeredQuestions,
        responseId: evaluatorResponse._id || evaluatorResponse.id,
      };
    if (progress >= 1)
      return {
        progress: 1,
        status: 'completo',
        hasResponse: true,
        answeredQuestions,
        responseId: evaluatorResponse._id || evaluatorResponse.id,
      };
    return {
      progress,
      status: 'em progresso',
      hasResponse: true,
      answeredQuestions,
      responseId: evaluatorResponse._id || evaluatorResponse.id,
    };
  };

  // Calcular progresso de cada avaliador
  const evaluator1Progress = getEvaluatorProgress(designatedEvaluators[0]);
  const evaluator2Progress = getEvaluatorProgress(designatedEvaluators[1]);

  // CORREÇÃO: Calcular progresso geral corretamente (média simples)
  const overallProgress = (evaluator1Progress.progress + evaluator2Progress.progress) / 2;

  // Verificar se há avaliadores adicionais (não designados)
  const additionalEvaluators = responses
    .filter(r => r.avaliador && !designatedEvaluators.find(de => de.id === r.avaliador.id))
    .map(r => r.avaliador);

  return (
    <View style={styles.evaluatorProgressContainer}>
      {/* Progresso Geral */}
      <View style={styles.overallProgressSection}>
        <View style={styles.overallProgressHeader}>
          <Text style={styles.overallProgressTitle}>{formTitle}</Text>
          <Badge style={styles.overallProgressBadge}>{Math.round(overallProgress * 100)}%</Badge>
        </View>

        <Text style={styles.overallProgressSubtitle}>Progresso Geral do Formulário</Text>

        <ProgressBar
          progress={overallProgress}
          color={overallProgress === 1 ? '#4CAF50' : AVAQualisTheme.colors.primary}
          style={styles.overallProgressBar}
        />
      </View>

      <Divider style={styles.progressDivider} />

      {/* Progresso Individual dos Avaliadores */}
      <Text style={styles.evaluatorsTitle}>Progresso por Avaliador:</Text>

      <View style={styles.evaluatorsContainer}>
        {/* Avaliador 1 (Esquerda) */}
        <View style={styles.evaluatorCard}>
          <View style={styles.evaluatorHeader}>
            <Text style={styles.evaluatorName}>
              {designatedEvaluators[0]?.nome || 'Avaliador 1'}
            </Text>
            <Chip
              mode="flat"
              compact
              style={[
                styles.statusChip,
                evaluator1Progress.status === 'completo' && styles.statusChipComplete,
                evaluator1Progress.status === 'em progresso' && styles.statusChipProgress,
              ]}
            >
              {evaluator1Progress.status}
            </Chip>
          </View>

          <Text style={styles.evaluatorLogin}>
            {designatedEvaluators[0]?.login || designatedEvaluators[0]?.email || 'Não designado'}
          </Text>

          <View style={styles.progressInfo}>
            <Text style={styles.progressPercentage}>
              {Math.round(evaluator1Progress.progress * 100)}%
            </Text>
            <Text style={styles.progressQuestions}>
              {evaluator1Progress.answeredQuestions} respostas
            </Text>
          </View>

          <ProgressBar
            progress={evaluator1Progress.progress}
            color={
              evaluator1Progress.status === 'completo'
                ? '#4CAF50'
                : evaluator1Progress.status === 'em progresso'
                  ? '#FF9800'
                  : '#E0E0E0'
            }
            style={styles.evaluatorProgressBar}
          />
        </View>

        {/* Avaliador 2 (Direita) */}
        <View style={styles.evaluatorCard}>
          <View style={styles.evaluatorHeader}>
            <Text style={styles.evaluatorName}>
              {designatedEvaluators[1]?.nome || 'Avaliador 2'}
            </Text>
            <Chip
              mode="flat"
              compact
              style={[
                styles.statusChip,
                evaluator2Progress.status === 'completo' && styles.statusChipComplete,
                evaluator2Progress.status === 'em progresso' && styles.statusChipProgress,
              ]}
            >
              {evaluator2Progress.status}
            </Chip>
          </View>

          <Text style={styles.evaluatorLogin}>
            {designatedEvaluators[1]?.login || designatedEvaluators[1]?.email || 'Não designado'}
          </Text>

          <View style={styles.progressInfo}>
            <Text style={styles.progressPercentage}>
              {Math.round(evaluator2Progress.progress * 100)}%
            </Text>
            <Text style={styles.progressQuestions}>
              {evaluator2Progress.answeredQuestions} respostas
            </Text>
          </View>

          <ProgressBar
            progress={evaluator2Progress.progress}
            color={
              evaluator2Progress.status === 'completo'
                ? '#4CAF50'
                : evaluator2Progress.status === 'em progresso'
                  ? '#FF9800'
                  : '#E0E0E0'
            }
            style={styles.evaluatorProgressBar}
          />
        </View>
      </View>

      {/* Avaliadores Adicionais (se houver) */}
      {additionalEvaluators.length > 0 && (
        <>
          <Divider style={styles.progressDivider} />
          <Text style={styles.additionalEvaluatorsTitle}>
            ⚠️ Avaliadores não designados que responderam:
          </Text>
          {additionalEvaluators.map((evaluator, index) => {
            const evaluatorResponse = responses.find(r => r.avaliador?.id === evaluator.id);
            const responseId = evaluatorResponse?._id || evaluatorResponse?.id;

            return (
              <View key={evaluator.id || index} style={styles.additionalEvaluatorContainer}>
                <Badge style={styles.additionalEvaluatorBadge}>
                  {evaluator.nome} ({evaluator.login})
                </Badge>
              </View>
            );
          })}
        </>
      )}
    </View>
  );
};

// NOVO: Componente para Sumário de Conformidade (MODIFICADO para excluir não designados)
const ConformitySummary = ({
  answers,
  formId,
  requirements,
  excludeUnauthorized = false,
  authorizedResponses = [],
}) => {
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    calculateAnalysis();
  }, [answers, excludeUnauthorized, authorizedResponses]);

  const calculateAnalysis = async () => {
    setLoading(true);
    try {
      let conforme = 0,
        naoConforme = 0,
        naoSeAplica = 0;
      let conformeRE = 0,
        naoConformeRE = 0,
        naoSeAplicaRE = 0;

      // Se devemos excluir não autorizados, usar apenas respostas autorizadas
      let answersToAnalyze = answers;
      if (excludeUnauthorized && authorizedResponses.length > 0) {
        answersToAnalyze = {};
        authorizedResponses.forEach(response => {
          Object.assign(answersToAnalyze, response.answers || {});
        });
      }

      for (const [questionId, answer] of Object.entries(answersToAnalyze)) {
        // Encontrar se é requisito essencial
        const requirement = requirements?.find(r => r.id === questionId || r.codigo === questionId);
        const isRE = requirement?.isEssential || false;

        switch (answer) {
          case 'conforme':
            conforme++;
            if (isRE) conformeRE++;
            break;
          case 'nao-conforme':
            naoConforme++;
            if (isRE) naoConformeRE++;
            break;
          case 'nao-se-aplica':
            naoSeAplica++;
            if (isRE) naoSeAplicaRE++;
            break;
        }
      }

      const totalValid = conforme + naoConforme;
      const totalValidRE = conformeRE + naoConformeRE;

      setAnalysis({
        conforme,
        naoConforme,
        naoSeAplica,
        conformeRE,
        naoConformeRE,
        naoSeAplicaRE,
        total: Object.keys(answersToAnalyze).length,
        percentConforme: totalValid > 0 ? ((conforme / totalValid) * 100).toFixed(1) : '0.0',
        percentNaoConforme: totalValid > 0 ? ((naoConforme / totalValid) * 100).toFixed(1) : '0.0',
        percentConformeRE:
          totalValidRE > 0 ? ((conformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
        percentNaoConformeRE:
          totalValidRE > 0 ? ((naoConformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
      });
    } catch (error) {
      console.error('Erro ao calcular análise:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !analysis) {
    return <ActivityIndicator size="small" />;
  }

  return (
    <View style={styles.conformitySummaryContainer}>
      <Text style={styles.conformitySummaryTitle}>📊 Resumo de Conformidade:</Text>

      <View style={styles.conformityGrid}>
        <View style={styles.conformityItem}>
          <Text style={styles.conformityValue}>✅ {analysis.conforme}</Text>
          <Text style={styles.conformityLabel}>Conforme</Text>
          <Text style={styles.conformityPercent}>{analysis.percentConforme}%</Text>
        </View>

        <View style={styles.conformityItem}>
          <Text style={styles.conformityValue}>❌ {analysis.naoConforme}</Text>
          <Text style={styles.conformityLabel}>Não Conforme</Text>
          <Text style={styles.conformityPercent}>{analysis.percentNaoConforme}%</Text>
        </View>

        <View style={styles.conformityItem}>
          <Text style={styles.conformityValue}>➖ {analysis.naoSeAplica}</Text>
          <Text style={styles.conformityLabel}>Não se Aplica</Text>
        </View>
      </View>

      {(analysis.conformeRE > 0 || analysis.naoConformeRE > 0) && (
        <>
          <Divider style={styles.conformityDivider} />

          <Text style={styles.conformitySubtitle}>⚠️ Requisitos Essenciais (RE):</Text>

          <View style={styles.conformityREGrid}>
            <View style={styles.conformityREItem}>
              <Text style={styles.conformityRELabel}>Conforme:</Text>
              <Text style={styles.conformityREValue}>
                {analysis.conformeRE} ({analysis.percentConformeRE}%)
              </Text>
            </View>

            <View style={styles.conformityREItem}>
              <Text style={styles.conformityRELabel}>Não Conforme:</Text>
              <Text style={styles.conformityREValue}>
                {analysis.naoConformeRE} ({analysis.percentNaoConformeRE}%)
              </Text>
            </View>
          </View>
        </>
      )}
    </View>
  );
};

// MELHORADO: Componente para exibir resultado consolidado (apenas avaliadores designados)
const ConsolidatedResult = ({
  requirement,
  responses,
  evaluators,
  expanded,
  onToggle,
  metadata,
}) => {
  const [unauthorizedModalVisible, setUnauthorizedModalVisible] = useState(false);
  const [selectedUnauthorizedEvaluator, setSelectedUnauthorizedEvaluator] = useState(null);

  // Usar avaliadores designados do metadata
  const designatedEvaluators = [
    metadata?.avaliador1 ? AVALIADORES.find(a => a.id === metadata.avaliador1) : null,
    metadata?.avaliador2 ? AVALIADORES.find(a => a.id === metadata.avaliador2) : null,
  ].filter(Boolean);

  // Se não há avaliadores no metadata, usar os primeiros 2
  if (designatedEvaluators.length === 0) {
    designatedEvaluators.push(...AVALIADORES.slice(0, 2));
  } else if (designatedEvaluators.length === 1) {
    const otherAvaliador = AVALIADORES.find(a => a.id !== designatedEvaluators[0].id);
    if (otherAvaliador) designatedEvaluators.push(otherAvaliador);
  }

  const getEvaluatorAnswer = evaluator => {
    if (!evaluator || !evaluator.id) return null;
    const response = responses.find(r => r.avaliador?.id === evaluator.id);
    if (!response) return null;
    return response.answers?.[requirement.id] || response.answers?.[requirement.codigo];
  };

  const getEvaluatorFinding = evaluator => {
    if (!evaluator || !evaluator.id) return null;
    const response = responses.find(r => r.avaliador?.id === evaluator.id);
    if (!response) return null;
    return response.findings?.[requirement.id] || response.findings?.[requirement.codigo];
  };

  const getEvaluatorAttachments = evaluator => {
    if (!evaluator || !evaluator.id) return [];
    const response = responses.find(r => r.avaliador?.id === evaluator.id);
    if (!response) return [];
    return (
      response.attachments?.[requirement.id] || response.attachments?.[requirement.codigo] || []
    );
  };

  // Coletar respostas dos avaliadores designados
  const answer1 = getEvaluatorAnswer(designatedEvaluators[0]);
  const answer2 = getEvaluatorAnswer(designatedEvaluators[1]);

  // Lógica de consolidação
  const getFinalResult = () => {
    // Se ambos não responderam
    if (!answer1 && !answer2) return 'não respondido';

    // Se apenas um respondeu, usar essa resposta
    if (!answer1 && answer2) return answer2;
    if (answer1 && !answer2) return answer1;

    // Se ambos responderam
    if (answer1 === answer2) return answer1;

    // Se há discordância, não-conforme tem prioridade
    if (answer1 === 'nao-conforme' || answer2 === 'nao-conforme') return 'nao-conforme';

    // Se um é conforme e outro não se aplica
    if (
      (answer1 === 'conforme' && answer2 === 'nao-se-aplica') ||
      (answer1 === 'nao-se-aplica' && answer2 === 'conforme')
    ) {
      return 'conforme';
    }

    return 'nao-se-aplica';
  };

  const finalResult = getFinalResult();

  const getResultColor = result => {
    switch (result) {
      case 'conforme':
        return '#4CAF50';
      case 'nao-conforme':
        return '#F44336';
      case 'nao-se-aplica':
        return '#9E9E9E';
      default:
        return '#FFC107';
    }
  };

  // Verificar se há respostas de avaliadores não designados
  const unauthorizedResponses = responses.filter(
    r =>
      r.avaliador &&
      !designatedEvaluators.find(de => de.id === r.avaliador.id) &&
      (r.answers?.[requirement.id] || r.answers?.[requirement.codigo])
  );

  const handleViewUnauthorizedResponse = evaluator => {
    setSelectedUnauthorizedEvaluator(evaluator);
    setUnauthorizedModalVisible(true);
  };

  return (
    <>
      <Card style={styles.resultCard}>
        <TouchableOpacity onPress={onToggle}>
          <Card.Content>
            <View style={styles.resultHeader}>
              <View style={styles.resultInfo}>
                <View style={styles.resultCodeContainer}>
                  <Chip mode="outlined" compact style={styles.codeChip}>
                    {requirement.codigo}
                  </Chip>
                  {requirement.isEssential && <Badge style={styles.essentialBadge}>RE</Badge>}
                </View>
                <Text style={styles.resultQuestion} numberOfLines={expanded ? undefined : 2}>
                  {requirement.question}
                </Text>
              </View>
              <View style={styles.resultStatus}>
                <View
                  style={[
                    styles.finalResultBadge,
                    { backgroundColor: getResultColor(finalResult) },
                  ]}
                >
                  <Text style={styles.finalResultText}>
                    {finalResult === 'nao-conforme'
                      ? '✕'
                      : getAnswerLabel(finalResult).split(' ')[0]}
                  </Text>
                </View>
                <IconButton
                  icon={expanded ? 'chevron-up' : 'chevron-down'}
                  size={24}
                  onPress={onToggle}
                />
              </View>
            </View>

            {expanded && (
              <>
                <Divider style={styles.divider} />

                {/* Tabela de Respostas com TODOS os avaliadores designados */}
                <View style={styles.answersTable}>
                  <View style={styles.tableHeader}>
                    <Text style={styles.tableHeaderText}>
                      {designatedEvaluators[0]?.nome?.split(' ')[0] || 'Avaliador 1'}
                    </Text>
                    <Text style={styles.tableHeaderText}>
                      {designatedEvaluators[1]?.nome?.split(' ')[0] || 'Avaliador 2'}
                    </Text>
                    <Text style={[styles.tableHeaderText, styles.tableHeaderFinal]}>
                      Resultado Final
                    </Text>
                  </View>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                      <Text
                        style={[
                          styles.answerText,
                          { color: getResultColor(answer1 || 'não respondido') },
                        ]}
                      >
                        {getAnswerLabel(answer1)}
                      </Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text
                        style={[
                          styles.answerText,
                          { color: getResultColor(answer2 || 'não respondido') },
                        ]}
                      >
                        {getAnswerLabel(answer2)}
                      </Text>
                    </View>
                    <View style={[styles.tableCell, styles.tableCellFinal]}>
                      <Text
                        style={[
                          styles.answerText,
                          styles.answerTextBold,
                          { color: getResultColor(finalResult) },
                        ]}
                      >
                        {getAnswerLabel(finalResult)}
                      </Text>
                    </View>
                  </View>
                </View>

                {/* Respostas de Avaliadores Não Designados */}
                {unauthorizedResponses.length > 0 && (
                  <View style={styles.unauthorizedResponsesSection}>
                    <Text style={styles.unauthorizedResponsesTitle}>
                      ⚠️ Respostas de avaliadores não designados:
                    </Text>
                    {unauthorizedResponses.map((response, index) => {
                      const answer =
                        response.answers?.[requirement.id] ||
                        response.answers?.[requirement.codigo];
                      return (
                        <TouchableOpacity
                          key={response.avaliador.id || index}
                          style={styles.unauthorizedResponseItem}
                          onPress={() => handleViewUnauthorizedResponse(response.avaliador)}
                        >
                          <Text style={styles.unauthorizedResponseName}>
                            {response.avaliador.nome}
                          </Text>
                          <Text style={styles.unauthorizedResponseAnswer}>
                            {getAnswerLabel(answer)}
                          </Text>
                          <MaterialCommunityIcons name="eye" size={20} color="#666" />
                        </TouchableOpacity>
                      );
                    })}
                  </View>
                )}

                {/* Detalhes do Requisito */}
                {(requirement.premissa || requirement.fontes || requirement.segmento) && (
                  <View style={styles.requirementDetails}>
                    {requirement.premissa && (
                      <View style={styles.detailSection}>
                        <Text style={styles.detailLabel}>Premissa:</Text>
                        <Text style={styles.detailText}>{requirement.premissa}</Text>
                      </View>
                    )}

                    {requirement.fontes && (
                      <View style={styles.detailSection}>
                        <Text style={styles.detailLabel}>Fontes:</Text>
                        <Text style={styles.detailText}>{requirement.fontes}</Text>
                      </View>
                    )}

                    {requirement.segmento && (
                      <View style={styles.detailSection}>
                        <Text style={styles.detailLabel}>Segmento:</Text>
                        <Text style={styles.detailText}>{requirement.segmento}</Text>
                      </View>
                    )}
                  </View>
                )}

                {/* Achados de cada avaliador designado */}
                <View style={styles.findingsContainer}>
                  <Text style={styles.findingsTitle}>📝 Achados dos Avaliadores:</Text>

                  {designatedEvaluators.map((evaluator, index) => {
                    if (!evaluator) return null;
                    const finding = getEvaluatorFinding(evaluator);
                    const attachments = getEvaluatorAttachments(evaluator);
                    const hasAnswer = getEvaluatorAnswer(evaluator) !== null;

                    return (
                      <View key={evaluator.id || index} style={styles.evaluatorFinding}>
                        <Text style={styles.evaluatorFindingName}>
                          {evaluator.nome || `Avaliador ${index + 1}`}:
                        </Text>
                        {!hasAnswer ? (
                          <Text style={styles.noResponseText}>Ainda não respondeu</Text>
                        ) : finding ? (
                          <Text style={styles.findingText}>{finding}</Text>
                        ) : (
                          <Text style={styles.noFindingText}>Sem achados registrados</Text>
                        )}

                        {attachments.length > 0 && (
                          <View style={styles.attachmentsSection}>
                            <Text style={styles.attachmentsTitle}>
                              📎 Anexos ({attachments.length}):
                            </Text>
                            {attachments.map((attachment, idx) => (
                              <TouchableOpacity
                                key={idx}
                                style={styles.attachmentItemCard}
                                onPress={() => handleOpenAttachment(attachment)}
                              >
                                <View style={styles.attachmentItemIcon}>
                                  <Text style={styles.attachmentIconEmoji}>
                                    {getFileEmoji(attachment.mimeType, attachment.name)}
                                  </Text>
                                </View>
                                <View style={styles.attachmentItemContent}>
                                  <Text style={styles.attachmentName} numberOfLines={1}>
                                    {attachment.name || 'Anexo'}
                                  </Text>
                                  {attachment.description && (
                                    <Text style={styles.attachmentDescription} numberOfLines={2}>
                                      {attachment.description}
                                    </Text>
                                  )}
                                  {attachment.validityDate && (
                                    <Text
                                      style={[
                                        styles.attachmentValidity,
                                        isExpired(attachment.validityDate) &&
                                          styles.attachmentValidityExpired,
                                        isNearExpiry(attachment.validityDate) &&
                                          styles.attachmentValidityWarning,
                                      ]}
                                    >
                                      📅 Válido até: {formatDate(attachment.validityDate)}
                                      {isExpired(attachment.validityDate) && ' (VENCIDO)'}
                                      {isNearExpiry(attachment.validityDate) &&
                                        !isExpired(attachment.validityDate) &&
                                        ' (PRÓXIMO DO VENCIMENTO)'}
                                    </Text>
                                  )}
                                </View>
                                <View style={styles.attachmentItemAction}>
                                  <MaterialCommunityIcons
                                    name="open-in-new"
                                    size={20}
                                    color="#666"
                                  />
                                </View>
                              </TouchableOpacity>
                            ))}
                          </View>
                        )}
                      </View>
                    );
                  })}
                </View>
              </>
            )}
          </Card.Content>
        </TouchableOpacity>
      </Card>

      {/* Modal para visualizar respostas não autorizadas */}
      <UnauthorizedEvaluatorModal
        visible={unauthorizedModalVisible}
        onDismiss={() => {
          setUnauthorizedModalVisible(false);
          setSelectedUnauthorizedEvaluator(null);
        }}
        evaluator={selectedUnauthorizedEvaluator}
        responses={responses}
        form={{ requirements: [requirement] }}
      />
    </>
  );
};

// NOVO: Componente para Seleção de Subgrupos
const SubgroupSelector = ({ forms, onSelectionChange }) => {
  const [selectedForms, setSelectedForms] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  const toggleFormSelection = formId => {
    const newSelection = selectedForms.includes(formId)
      ? selectedForms.filter(id => id !== formId)
      : [...selectedForms, formId];

    setSelectedForms(newSelection);
    onSelectionChange(newSelection);
  };

  const selectAll = () => {
    const allIds = forms.map(f => f.id);
    setSelectedForms(allIds);
    onSelectionChange(allIds);
  };

  const clearSelection = () => {
    setSelectedForms([]);
    onSelectionChange([]);
  };

  return (
    <>
      <TouchableOpacity style={styles.subgroupButton} onPress={() => setModalVisible(true)}>
        <MaterialCommunityIcons
          name="filter-variant"
          size={20}
          color={AVAQualisTheme.colors.primary}
        />
        <Text style={styles.subgroupButtonText}>
          Selecionar Subgrupo ({selectedForms.length} selecionados)
        </Text>
      </TouchableOpacity>

      <Modal
        visible={modalVisible}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setModalVisible(false)}
      >
        <View style={styles.subgroupModalOverlay}>
          <View style={styles.subgroupModalContainer}>
            <View style={styles.subgroupModalHeader}>
              <Text style={styles.subgroupModalTitle}>Selecionar Formulários para Análise</Text>
              <IconButton icon="close" size={24} onPress={() => setModalVisible(false)} />
            </View>

            <View style={styles.subgroupModalActions}>
              <Button mode="outlined" onPress={selectAll} compact>
                Selecionar Todos
              </Button>
              <Button mode="outlined" onPress={clearSelection} compact>
                Limpar Seleção
              </Button>
            </View>

            <ScrollView style={styles.subgroupModalContent}>
              {forms.map(form => (
                <TouchableOpacity
                  key={form.id}
                  style={styles.subgroupItem}
                  onPress={() => toggleFormSelection(form.id)}
                >
                  <Checkbox
                    status={selectedForms.includes(form.id) ? 'checked' : 'unchecked'}
                    onPress={() => toggleFormSelection(form.id)}
                  />
                  <View style={styles.subgroupItemInfo}>
                    <Text style={styles.subgroupItemTitle}>{form.title}</Text>
                    <Text style={styles.subgroupItemDescription} numberOfLines={1}>
                      {form.description}
                    </Text>
                  </View>
                </TouchableOpacity>
              ))}
            </ScrollView>

            <View style={styles.subgroupModalFooter}>
              <Button
                mode="contained"
                onPress={() => setModalVisible(false)}
                style={styles.subgroupModalButton}
              >
                Aplicar Filtro ({selectedForms.length} selecionados)
              </Button>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

// NOVO: Componente para Análise Global (MODIFICADO para excluir não designados)
const GlobalAnalysis = ({ forms, responses, selectedFormIds = [] }) => {
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    calculateGlobalAnalysis();
  }, [forms, responses, selectedFormIds]);

  const calculateGlobalAnalysis = async () => {
    setLoading(true);
    try {
      let totalConforme = 0,
        totalNaoConforme = 0,
        totalNaoSeAplica = 0;
      let totalConformeRE = 0,
        totalNaoConformeRE = 0,
        totalNaoSeAplicaRE = 0;
      let totalQuestions = 0;
      let totalForms = 0;
      let totalResponses = 0;
      let totalUnauthorizedResponses = 0;

      // Filtrar formulários se houver seleção
      const formsToAnalyze =
        selectedFormIds.length > 0 ? forms.filter(f => selectedFormIds.includes(f.id)) : forms;

      for (const form of formsToAnalyze) {
        const formResponses = responses.filter(r => r.formId === form.id);
        if (formResponses.length === 0) continue;

        totalForms++;

        // Obter avaliadores designados
        const designatedEvaluators = [form.metadata?.avaliador1, form.metadata?.avaliador2].filter(
          Boolean
        );

        // Filtrar apenas respostas dos avaliadores designados
        const authorizedResponses = formResponses.filter(r =>
          designatedEvaluators.includes(r.avaliador?.id)
        );

        const unauthorizedResponses = formResponses.filter(
          r => !designatedEvaluators.includes(r.avaliador?.id)
        );

        totalUnauthorizedResponses += unauthorizedResponses.length;

        // Consolidar respostas por questão (apenas autorizados)
        const consolidatedAnswers = {};

        authorizedResponses.forEach(response => {
          totalResponses++;
          Object.entries(response.answers || {}).forEach(([questionId, answer]) => {
            if (!consolidatedAnswers[questionId]) {
              consolidatedAnswers[questionId] = [];
            }
            consolidatedAnswers[questionId].push(answer);
          });
        });

        // Calcular resultado consolidado para cada questão
        Object.entries(consolidatedAnswers).forEach(([questionId, answers]) => {
          if (answers.length === 0) return;

          totalQuestions++;

          // Determinar se é requisito essencial
          const requirement = form.requirements?.find(
            r => r.id === questionId || r.codigo === questionId
          );
          const isRE = requirement?.isEssential || false;

          // Lógica de consolidação
          let finalResult;
          if (answers.every(a => a === answers[0])) {
            finalResult = answers[0];
          } else if (answers.some(a => a === 'nao-conforme')) {
            finalResult = 'nao-conforme';
          } else if (answers.some(a => a === 'conforme')) {
            finalResult = 'conforme';
          } else {
            finalResult = 'nao-se-aplica';
          }

          switch (finalResult) {
            case 'conforme':
              totalConforme++;
              if (isRE) totalConformeRE++;
              break;
            case 'nao-conforme':
              totalNaoConforme++;
              if (isRE) totalNaoConformeRE++;
              break;
            case 'nao-se-aplica':
              totalNaoSeAplica++;
              if (isRE) totalNaoSeAplicaRE++;
              break;
          }
        });
      }

      const totalValid = totalConforme + totalNaoConforme;
      const totalValidRE = totalConformeRE + totalNaoConformeRE;

      setAnalysis({
        totalForms,
        totalResponses,
        totalUnauthorizedResponses,
        totalQuestions,
        totalConforme,
        totalNaoConforme,
        totalNaoSeAplica,
        totalConformeRE,
        totalNaoConformeRE,
        totalNaoSeAplicaRE,
        percentConforme: totalValid > 0 ? ((totalConforme / totalValid) * 100).toFixed(1) : '0.0',
        percentNaoConforme:
          totalValid > 0 ? ((totalNaoConforme / totalValid) * 100).toFixed(1) : '0.0',
        percentConformeRE:
          totalValidRE > 0 ? ((totalConformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
        percentNaoConformeRE:
          totalValidRE > 0 ? ((totalNaoConformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
      });
    } catch (error) {
      console.error('Erro ao calcular análise global:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !analysis) {
    return (
      <Card style={styles.globalAnalysisCard}>
        <Card.Content>
          <ActivityIndicator size="large" color={AVAQualisTheme.colors.primary} />
        </Card.Content>
      </Card>
    );
  }

  return (
    <Card style={styles.globalAnalysisCard}>
      <Card.Content>
        <View style={styles.globalAnalysisHeader}>
          <Text style={styles.globalAnalysisTitle}>
            📊 Análise {selectedFormIds.length > 0 ? 'do Subgrupo' : 'Global'}
          </Text>
          {selectedFormIds.length > 0 && (
            <Badge style={styles.globalAnalysisBadge}>{selectedFormIds.length} formulários</Badge>
          )}
        </View>

        <View style={styles.globalAnalysisStats}>
          <View style={styles.globalStatItem}>
            <Text style={styles.globalStatValue}>{analysis.totalForms}</Text>
            <Text style={styles.globalStatLabel}>Formulários</Text>
          </View>
          <View style={styles.globalStatItem}>
            <Text style={styles.globalStatValue}>{analysis.totalResponses}</Text>
            <Text style={styles.globalStatLabel}>Respostas Válidas</Text>
          </View>
          <View style={styles.globalStatItem}>
            <Text style={styles.globalStatValue}>{analysis.totalQuestions}</Text>
            <Text style={styles.globalStatLabel}>Questões</Text>
          </View>
        </View>

        {analysis.totalUnauthorizedResponses > 0 && (
          <View style={styles.unauthorizedWarning}>
            <MaterialCommunityIcons name="alert" size={20} color="#FF6F00" />
            <Text style={styles.unauthorizedWarningText}>
              {analysis.totalUnauthorizedResponses} resposta(s) de avaliadores não designados foram
              excluídas desta análise
            </Text>
          </View>
        )}

        <Divider style={styles.globalAnalysisDivider} />

        <Text style={styles.globalAnalysisSubtitle}>
          Conformidade Geral (apenas avaliadores designados):
        </Text>

        <View style={styles.globalConformityGrid}>
          <View style={styles.globalConformityItem}>
            <View style={styles.globalConformityHeader}>
              <Text style={styles.globalConformityIcon}>✅</Text>
              <Text style={styles.globalConformityPercent}>{analysis.percentConforme}%</Text>
            </View>
            <Text style={styles.globalConformityLabel}>Conforme</Text>
            <Text style={styles.globalConformityCount}>{analysis.totalConforme} questões</Text>
          </View>

          <View style={styles.globalConformityItem}>
            <View style={styles.globalConformityHeader}>
              <Text style={styles.globalConformityIcon}>❌</Text>
              <Text style={styles.globalConformityPercent}>{analysis.percentNaoConforme}%</Text>
            </View>
            <Text style={styles.globalConformityLabel}>Não Conforme</Text>
            <Text style={styles.globalConformityCount}>{analysis.totalNaoConforme} questões</Text>
          </View>
        </View>

        {(analysis.totalConformeRE > 0 || analysis.totalNaoConformeRE > 0) && (
          <>
            <Divider style={styles.globalAnalysisDivider} />

            <Text style={styles.globalAnalysisSubtitle}>⚠️ Requisitos Essenciais:</Text>

            <View style={styles.globalREStats}>
              <View style={styles.globalREItem}>
                <Text style={styles.globalRELabel}>Conforme:</Text>
                <Text style={styles.globalREValue}>
                  {analysis.totalConformeRE} ({analysis.percentConformeRE}%)
                </Text>
              </View>

              <View style={styles.globalREItem}>
                <Text style={styles.globalRELabel}>Não Conforme:</Text>
                <Text style={styles.globalREValue}>
                  {analysis.totalNaoConformeRE} ({analysis.percentNaoConformeRE}%)
                </Text>
              </View>

              <View style={styles.globalREItem}>
                <Text style={styles.globalRELabel}>Não se Aplica:</Text>
                <Text style={styles.globalREValue}>{analysis.totalNaoSeAplicaRE}</Text>
              </View>
            </View>
          </>
        )}
      </Card.Content>
    </Card>
  );
};

// Componente principal
export default function ResultsScreen({ onBack, currentUser, onEditForm }) {
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [forms, setForms] = useState([]);
  const [responses, setResponses] = useState([]);
  const [expandedItems, setExpandedItems] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedForm, setSelectedForm] = useState(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [dialogContent, setDialogContent] = useState({ title: '', message: '', actions: [] });
  const [downloadingBackup, setDownloadingBackup] = useState(false);
  const [unauthorizedEvaluatorModalVisible, setUnauthorizedEvaluatorModalVisible] = useState(false);
  const [selectedUnauthorizedEvaluator, setSelectedUnauthorizedEvaluator] = useState(null);
  const [selectedUnauthorizedResponses, setSelectedUnauthorizedResponses] = useState([]);
  const [selectedUnauthorizedForm, setSelectedUnauthorizedForm] = useState(null);

  // Adicionar este estado junto com os outros
  const [deleteEvaluatorModalVisible, setDeleteEvaluatorModalVisible] = useState(false);
  const [selectedEvaluatorToDelete, setSelectedEvaluatorToDelete] = useState(null);

  // Estados para filtros
  const [filterMenuVisible, setFilterMenuVisible] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('all');

  // Estado para subgrupos
  const [selectedSubgroup, setSelectedSubgroup] = useState([]);

  // Estado para armazenar validações das respostas
  const [responseValidations, setResponseValidations] = useState({});

  // NOVOS ESTADOS: Para exclusão de formulários

  const [deletingForm, setDeletingForm] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  // Função para buscar validações de todas as respostas
  const loadValidations = async responses => {
    try {
      const validations = {};

      for (const response of responses) {
        try {
          // Buscar a resposta completa do servidor para verificar validação
          const serverResponse = await api.getResponseById(response.id);

          if (serverResponse && serverResponse.validacao && serverResponse.validacao.validadoPor) {
            validations[response.id] = {
              validadoPor: serverResponse.validacao.validadoPor.nome || 'Não identificado',
              dataValidacao: serverResponse.validacao.dataValidacao,
              revalidacoes: serverResponse.validacao.revalidacoes || [],
            };
          }
        } catch (error) {
          console.warn(`Erro ao buscar validação para resposta ${response.id}:`, error);
        }
      }

      setResponseValidations(validations);
    } catch (error) {
      console.error('Erro ao carregar validações:', error);
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const [formsData, responsesData] = await Promise.all([api.getForms(), api.getResponses()]);

      // NOVO: Aplicar filtros de permissão
      const filteredForms = formsData.filter(form => AuthService.canViewForm(form));

      setForms(filteredForms);
      setResponses(responsesData);

      // Carregar validações das respostas
      await loadValidations(responsesData);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      Alert.alert('Erro', 'Não foi possível carregar os dados do servidor');
    } finally {
      setLoading(false);
    }
  };

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    await loadData();
    // Recarregar validações também
    const [formsData, responsesData] = await Promise.all([api.getForms(), api.getResponses()]);
    await loadValidations(responsesData);
    setRefreshing(false);
  }, []);

  const toggleExpanded = itemId => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  // NOVA FUNÇÃO: Deletar resposta específica
  const deleteEvaluatorResponse = async (responseId, evaluator) => {
    try {
      setLoading(true);

      // Chamar API para deletar resposta
      await api.deleteResponse(responseId);

      // Recarregar dados
      await loadData();

      Alert.alert('✅ Sucesso', `O envio de ${evaluator.nome} foi excluído com sucesso.`);
    } catch (error) {
      console.error('Erro ao deletar resposta:', error);
      Alert.alert('❌ Erro', 'Não foi possível excluir o envio. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  // NOVA FUNÇÃO: Excluir formulário completo
  // NOVA FUNÇÃO: Excluir formulário completo
  const deleteFormComplete = async form => {
    try {
      setDeletingForm(true);
      console.log(`🗑️ Excluindo formulário completo: ${form.id}`);

      // Chamar API para excluir formulário completo com todas as respostas
      await api.deleteFormComplete(form.id);

      // Recarregar dados
      await loadData();

      Alert.alert(
        '✅ Exclusão Completa',
        `O formulário "${form.title}" e todas as suas respostas foram excluídos permanentemente.`
      );
    } catch (error) {
      console.error('❌ Erro ao excluir formulário completo:', error);
      Alert.alert('❌ Erro na Exclusão', 'Não foi possível excluir o formulário. Tente novamente.');
    } finally {
      setDeleteFormModalVisible(false);
      setDeleteOptionsModalVisible(false); // IMPORTANTE: fechar ambos
      setSelectedFormToDelete(null);
      setDeletingForm(false);
    }
  };

  // NOVA FUNÇÃO: Excluir respostas de avaliador específico
  // NOVA FUNÇÃO: Excluir respostas de avaliador específico
  const deleteEvaluatorResponses = async (evaluator, form) => {
    try {
      setDeletingForm(true);
      console.log(
        `🗑️ Excluindo respostas do avaliador ${evaluator.id} para o formulário ${form.id}`
      );

      // Chamar API para excluir respostas específicas do avaliador
      await api.deleteResponsesByEvaluator(form.id, evaluator.id);

      // Recarregar dados
      await loadData();

      Alert.alert(
        '✅ Exclusão Concluída',
        `As respostas de ${evaluator.nome} foram excluídas do formulário "${form.title}".`
      );
    } catch (error) {
      console.error('❌ Erro ao excluir respostas do avaliador:', error);
      Alert.alert('❌ Erro na Exclusão', 'Não foi possível excluir as respostas. Tente novamente.');
    } finally {
      setDeleteOptionsModalVisible(false);
      setSelectedFormToDelete(null);
      setDeletingForm(false);
    }
  };
  // 1. ADICIONAR NOVOS ESTADOS para controlar os modais de deleção (após os outros estados)
  const [deleteOptionsModalVisible, setDeleteOptionsModalVisible] = useState(false);
  const [deleteFormModalVisible, setDeleteFormModalVisible] = useState(false);
  const [selectedFormToDelete, setSelectedFormToDelete] = useState(null);

  // 2. SUBSTITUIR a função showDeleteOptions por esta versão:
  const showDeleteOptions = form => {
    console.log('🟣 showDeleteOptions chamado para formulário:', form.title);
    console.log('🟣 Form ID:', form.id);
    setSelectedFormToDelete(form);
    setDeleteOptionsModalVisible(true);
  };
  // 3. SUBSTITUIR a função confirmDeleteForm por esta (simplificada):
  const confirmDeleteForm = () => {
    // NÃO fechar o modal de opções ainda
    setDeleteFormModalVisible(true);
  };

  // NOVA FUNÇÃO: Confirmar exclusão de respostas do avaliador
  const confirmDeleteEvaluator = evaluator => {
    Alert.alert(
      '🗑️ Confirmar Exclusão',
      `Deseja realmente excluir TODAS as respostas de ${evaluator.nome} para este formulário?\n\nEsta ação não pode ser desfeita.`,
      [
        { text: 'Cancelar', style: 'cancel' },
        {
          text: 'Excluir',
          style: 'destructive',
          onPress: () => deleteEvaluatorResponses(evaluator),
        },
      ]
    );
  };

  // MODIFICADA: Função para obter estatísticas do formulário (excluindo não designados)
  const getFormStatistics = (formId, formMetadata = {}) => {
    const formResponses = responses.filter(r => r.formId === formId);

    // Obter avaliadores designados
    const designatedEvaluators = [formMetadata?.avaliador1, formMetadata?.avaliador2].filter(
      Boolean
    );

    // Se não há respostas, retornar estatísticas vazias
    if (formResponses.length === 0) return null;

    let totalConforme = 0;
    let totalNaoConforme = 0;
    let totalNaoSeAplica = 0;
    let totalQuestions = 0;

    // Contar respostas consolidadas
    const consolidatedAnswers = {};

    // Processar apenas respostas dos avaliadores designados
    formResponses.forEach(response => {
      // Verificar se é um avaliador designado
      const isDesignated = designatedEvaluators.includes(response.avaliador?.id);
      if (!isDesignated && designatedEvaluators.length > 0) return;

      Object.entries(response.answers || {}).forEach(([questionId, answer]) => {
        if (!consolidatedAnswers[questionId]) {
          consolidatedAnswers[questionId] = [];
        }
        consolidatedAnswers[questionId].push(answer);
      });
    });

    // Calcular estatísticas baseadas em respostas consolidadas
    Object.entries(consolidatedAnswers).forEach(([questionId, answers]) => {
      if (answers.length > 0) {
        totalQuestions++;

        // Determinar resultado consolidado
        let finalResult;
        if (answers.every(a => a === answers[0])) {
          finalResult = answers[0];
        } else if (answers.some(a => a === 'nao-conforme')) {
          finalResult = 'nao-conforme';
        } else if (answers.some(a => a === 'conforme')) {
          finalResult = 'conforme';
        } else {
          finalResult = 'nao-se-aplica';
        }

        switch (finalResult) {
          case 'conforme':
            totalConforme++;
            break;
          case 'nao-conforme':
            totalNaoConforme++;
            break;
          case 'nao-se-aplica':
            totalNaoSeAplica++;
            break;
        }
      }
    });

    return {
      totalConforme,
      totalNaoConforme,
      totalNaoSeAplica,
      totalQuestions,
      conformityRate:
        totalQuestions > 0
          ? Math.round((totalConforme / (totalConforme + totalNaoConforme)) * 100)
          : 0,
    };
  };

  // NOVA FUNÇÃO: Obter análise detalhada da unidade
  const getUnitDetailedAnalysis = (unit, forms) => {
    let unitConforme = 0,
      unitNaoConforme = 0,
      unitNaoSeAplica = 0;
    let unitConformeRE = 0,
      unitNaoConformeRE = 0,
      unitNaoSeAplicaRE = 0;
    let totalQuestions = 0;
    let evaluatorDetails = {};
    let attachmentsSummary = [];

    forms.forEach(form => {
      const formResponses = responses.filter(r => r.formId === form.id);

      // Obter avaliadores designados
      const designatedEvaluators = [
        form.metadata?.avaliador1 ? AVALIADORES.find(a => a.id === form.metadata.avaliador1) : null,
        form.metadata?.avaliador2 ? AVALIADORES.find(a => a.id === form.metadata.avaliador2) : null,
      ].filter(Boolean);

      // Processar cada requisito
      form.requirements?.forEach(requirement => {
        // Processar resposta de cada avaliador
        designatedEvaluators.forEach(evaluator => {
          if (!evaluator) return;

          const response = formResponses.find(r => r.avaliador?.id === evaluator.id);
          if (!response) return;

          const answer =
            response.answers?.[requirement.id] || response.answers?.[requirement.codigo];
          const finding =
            response.findings?.[requirement.id] || response.findings?.[requirement.codigo];
          const attachments =
            response.attachments?.[requirement.id] ||
            response.attachments?.[requirement.codigo] ||
            [];

          // Inicializar dados do avaliador se necessário
          if (!evaluatorDetails[evaluator.id]) {
            evaluatorDetails[evaluator.id] = {
              nome: evaluator.nome,
              email: evaluator.login || evaluator.email,
              level: evaluator.level,
              totalRespostas: 0,
              conforme: 0,
              naoConforme: 0,
              naoSeAplica: 0,
              conformeRE: 0,
              naoConformeRE: 0,
              naoSeAplicaRE: 0,
              attachments: [],
            };
          }

          if (answer) {
            evaluatorDetails[evaluator.id].totalRespostas++;
            totalQuestions++;

            // Contar respostas
            switch (answer) {
              case 'conforme':
                unitConforme++;
                evaluatorDetails[evaluator.id].conforme++;
                if (requirement.isEssential) {
                  unitConformeRE++;
                  evaluatorDetails[evaluator.id].conformeRE++;
                }
                break;
              case 'nao-conforme':
                unitNaoConforme++;
                evaluatorDetails[evaluator.id].naoConforme++;
                if (requirement.isEssential) {
                  unitNaoConformeRE++;
                  evaluatorDetails[evaluator.id].naoConformeRE++;
                }
                break;
              case 'nao-se-aplica':
                unitNaoSeAplica++;
                evaluatorDetails[evaluator.id].naoSeAplica++;
                if (requirement.isEssential) {
                  unitNaoSeAplicaRE++;
                  evaluatorDetails[evaluator.id].naoSeAplicaRE++;
                }
                break;
            }

            // Processar anexos
            attachments.forEach(attachment => {
              const attachmentDetail = {
                ...attachment,
                avaliadorNome: evaluator.nome,
                avaliadorId: evaluator.id,
                formTitle: form.title,
                requirementCode: requirement.codigo,
                requirementQuestion: requirement.question,
              };
              attachmentsSummary.push(attachmentDetail);
              evaluatorDetails[evaluator.id].attachments.push(attachmentDetail);
            });
          }
        });
      });
    });

    // Calcular percentuais
    const totalValid = unitConforme + unitNaoConforme;
    const totalValidRE = unitConformeRE + unitNaoConformeRE;

    return {
      totalQuestions,
      unitConforme,
      unitNaoConforme,
      unitNaoSeAplica,
      unitConformeRE,
      unitNaoConformeRE,
      unitNaoSeAplicaRE,
      percentConforme: totalValid > 0 ? ((unitConforme / totalValid) * 100).toFixed(1) : '0.0',
      percentNaoConforme:
        totalValid > 0 ? ((unitNaoConforme / totalValid) * 100).toFixed(1) : '0.0',
      percentConformeRE:
        totalValidRE > 0 ? ((unitConformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
      percentNaoConformeRE:
        totalValidRE > 0 ? ((unitNaoConformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
      evaluatorDetails,
      attachmentsSummary,
    };
  };

  // NOVA FUNÇÃO: Obter análise detalhada do processo
  const getProcessDetailedAnalysis = (processo, forms) => {
    let processConforme = 0,
      processNaoConforme = 0,
      processNaoSeAplica = 0;
    let processConformeRE = 0,
      processNaoConformeRE = 0,
      processNaoSeAplicaRE = 0;
    let totalQuestions = 0;
    let evaluatorDetails = {};
    let attachmentsSummary = [];

    forms.forEach(form => {
      const formResponses = responses.filter(r => r.formId === form.id);

      // Obter avaliadores designados
      const designatedEvaluators = [
        form.metadata?.avaliador1 ? AVALIADORES.find(a => a.id === form.metadata.avaliador1) : null,
        form.metadata?.avaliador2 ? AVALIADORES.find(a => a.id === form.metadata.avaliador2) : null,
      ].filter(Boolean);

      // Processar cada requisito
      form.requirements?.forEach(requirement => {
        // Processar resposta de cada avaliador
        designatedEvaluators.forEach(evaluator => {
          if (!evaluator) return;

          const response = formResponses.find(r => r.avaliador?.id === evaluator.id);
          if (!response) return;

          const answer =
            response.answers?.[requirement.id] || response.answers?.[requirement.codigo];
          const finding =
            response.findings?.[requirement.id] || response.findings?.[requirement.codigo];
          const attachments =
            response.attachments?.[requirement.id] ||
            response.attachments?.[requirement.codigo] ||
            [];

          // Inicializar dados do avaliador se necessário
          if (!evaluatorDetails[evaluator.id]) {
            evaluatorDetails[evaluator.id] = {
              nome: evaluator.nome,
              email: evaluator.login || evaluator.email,
              level: evaluator.level,
              totalRespostas: 0,
              conforme: 0,
              naoConforme: 0,
              naoSeAplica: 0,
              conformeRE: 0,
              naoConformeRE: 0,
              naoSeAplicaRE: 0,
              attachments: [],
            };
          }

          if (answer) {
            evaluatorDetails[evaluator.id].totalRespostas++;
            totalQuestions++;

            // Contar respostas
            switch (answer) {
              case 'conforme':
                processConforme++;
                evaluatorDetails[evaluator.id].conforme++;
                if (requirement.isEssential) {
                  processConformeRE++;
                  evaluatorDetails[evaluator.id].conformeRE++;
                }
                break;
              case 'nao-conforme':
                processNaoConforme++;
                evaluatorDetails[evaluator.id].naoConforme++;
                if (requirement.isEssential) {
                  processNaoConformeRE++;
                  evaluatorDetails[evaluator.id].naoConformeRE++;
                }
                break;
              case 'nao-se-aplica':
                processNaoSeAplica++;
                evaluatorDetails[evaluator.id].naoSeAplica++;
                if (requirement.isEssential) {
                  processNaoSeAplicaRE++;
                  evaluatorDetails[evaluator.id].naoSeAplicaRE++;
                }
                break;
            }

            // Processar anexos
            attachments.forEach(attachment => {
              const attachmentDetail = {
                ...attachment,
                avaliadorNome: evaluator.nome,
                avaliadorId: evaluator.id,
                formTitle: form.title,
                requirementCode: requirement.codigo,
                requirementQuestion: requirement.question,
              };
              attachmentsSummary.push(attachmentDetail);
              evaluatorDetails[evaluator.id].attachments.push(attachmentDetail);
            });
          }
        });
      });
    });

    // Calcular percentuais
    const totalValid = processConforme + processNaoConforme;
    const totalValidRE = processConformeRE + processNaoConformeRE;

    return {
      totalQuestions,
      processConforme,
      processNaoConforme,
      processNaoSeAplica,
      processConformeRE,
      processNaoConformeRE,
      processNaoSeAplicaRE,
      percentConforme: totalValid > 0 ? ((processConforme / totalValid) * 100).toFixed(1) : '0.0',
      percentNaoConforme:
        totalValid > 0 ? ((processNaoConforme / totalValid) * 100).toFixed(1) : '0.0',
      percentConformeRE:
        totalValidRE > 0 ? ((processConformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
      percentNaoConformeRE:
        totalValidRE > 0 ? ((processNaoConformeRE / totalValidRE) * 100).toFixed(1) : 'N/A',
      evaluatorDetails,
      attachmentsSummary,
    };
  };

  const showDialog = (title, message, actions = []) => {
    setDialogContent({ title, message, actions });
    setDialogVisible(true);
  };

  // MODIFICADA: Função para editar formulário preservando avaliador original
  const handleEditForm = form => {
    if (onEditForm) {
      // Marcar que está vindo da tela de resultados
      const formWithResultsFlag = {
        ...form,
        isEditingFromResults: true,
      };
      onEditForm(formWithResultsFlag);
    } else {
      Alert.alert('Editar', 'Função de edição não implementada');
    }
  };

  // NOVA FUNÇÃO: Visualizar respostas de avaliador não designado
  const handleViewUnauthorizedResponses = (evaluator, formResponses, form) => {
    setSelectedUnauthorizedEvaluator(evaluator);
    setSelectedUnauthorizedResponses(formResponses);
    setSelectedUnauthorizedForm(form);
    setUnauthorizedEvaluatorModalVisible(true);
  };

  const getFilteredForms = () => {
    let filtered = forms;

    // Aplicar filtro de busca
    if (searchQuery) {
      filtered = filtered.filter(
        form =>
          form.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          form.description.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Aplicar filtro de status
    switch (selectedFilter) {
      case 'complete':
        filtered = filtered.filter(form => {
          const formResponses = responses.filter(r => r.formId === form.id);
          const designatedEvaluators = [
            form.metadata?.avaliador1,
            form.metadata?.avaliador2,
          ].filter(Boolean);

          const authorizedResponses = formResponses.filter(r =>
            designatedEvaluators.includes(r.avaliador?.id)
          );

          return authorizedResponses.length >= 2;
        });
        break;
      case 'incomplete':
        filtered = filtered.filter(form => {
          const formResponses = responses.filter(r => r.formId === form.id);
          const designatedEvaluators = [
            form.metadata?.avaliador1,
            form.metadata?.avaliador2,
          ].filter(Boolean);

          const authorizedResponses = formResponses.filter(r =>
            designatedEvaluators.includes(r.avaliador?.id)
          );

          return authorizedResponses.length > 0 && authorizedResponses.length < 2;
        });
        break;
      case 'no-responses':
        filtered = filtered.filter(form => {
          const formResponses = responses.filter(r => r.formId === form.id);
          return formResponses.length === 0;
        });
        break;
    }

    return filtered;
  };

  // MELHORADA: Download de backup em Excel com mais detalhes xyz
  // MELHORADA: Download de backup em Excel com mais detalhes e tratamento de erros

  // Adicione esta função auxiliar antes da função downloadBackup
  const createExcelHyperlink = (url, displayText = url) => {
    // Para Excel em inglês
    //return `=HYPERLINK("${url}","${displayText}")`;

    // Se você souber que sempre será Excel em português, use:
    return `=HIPERLINK("${url}";"${displayText}")`;
  };

  const downloadBackup = async () => {
    setDownloadingBackup(true);

    // Função auxiliar para limitar o tamanho do texto e tratar URLs base64
    const sanitizeForExcel = (text, maxLength = 32000) => {
      if (!text) return '';

      // Se for uma URL base64, substituir por um placeholder
      if (typeof text === 'string' && text.startsWith('data:')) {
        // Extrair o tipo MIME
        const mimeMatch = text.match(/data:([^;]+)/);
        const mimeType = mimeMatch ? mimeMatch[1] : 'unknown';
        return `[Anexo Base64 - ${mimeType}]`;
      }

      // Se for muito longo, truncar
      if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + '...';
      }

      return text;
    };

    // Função para obter URL limpa do anexo
    // Substitua a função getCleanAttachmentUrl por esta versão mais simples:
    const getCleanAttachmentUrl = (attachment, responseId, questionId, attachmentIndex) => {
      // Para Excel, criar URL direta para a API
      if (responseId && questionId !== undefined && attachmentIndex !== undefined) {
        const baseUrl = 'https://avaqualis-server-5b5d8ca54885.herokuapp.com';
        return `${baseUrl}/api/attachment?responseId=${responseId}&questionId=${questionId}&index=${attachmentIndex}`;
      }

      // Fallback para URL original
      let url = attachment.supabaseUrl || attachment.url || attachment.uri || '';

      // Se for base64, retornar indicação
      if (url.startsWith('data:')) {
        return '[Anexo Base64 - Requer processamento]';
      }

      return url;
    };

    try {
      console.log('📥 Iniciando download de backup...');
      console.log(`📊 Total de formulários: ${forms.length}`);
      console.log(`📊 Total de respostas: ${responses.length}`);

      // Criar workbook
      const wb = XLSX.utils.book_new();

      // Aba 1: Resumo Geral
      const summaryData = [];

      // Cabeçalho do resumo
      summaryData.push(['BACKUP COMPLETO - AVAQUALIS']);
      summaryData.push(['Data de Geração:', new Date().toLocaleString('pt-BR')]);
      summaryData.push(['Usuário:', currentUser?.nome || 'Não identificado']);
      summaryData.push(['']);
      summaryData.push(['RESUMO GERAL']);
      summaryData.push(['Total de Formulários:', forms.length]);
      summaryData.push(['Total de Respostas:', responses.length]);
      summaryData.push(['']);

      const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(wb, summarySheet, 'Resumo');

      console.log('✅ Aba Resumo criada');

      // Aba 2: Dados Detalhados por Formulário
      const detailedData = [];

      // Cabeçalho da planilha detalhada
      // Cabeçalho da planilha detalhada
      detailedData.push([
        'ID Formulário',
        'Título do Formulário',
        'Descrição',
        'Data Criação',
        'Última Modificação',
        'Código Requisito',
        'Pergunta',
        'Requisito Essencial',
        'Premissa',
        'Fontes',
        'Segmento',
        'ID Avaliador',
        'Nome Avaliador',
        'Email Avaliador',
        'Level Avaliador',
        'Avaliador Designado',
        'Resposta',
        'Data Resposta',
        'Achados',
        'Anexos (Nome)',
        'Anexos (Descrição)',
        'Anexos (Validade)',
        'Anexos (Status Validade)',
        'Anexos (URL)',
        'Anexos (Tipo MIME)',
        'Anexos (Tamanho)',
        'Anexos (Data Criação)',
        'Unidades Organizacionais',
        'Hierarquia Unidade',
        'Avaliador 1 Designado (Nome)',
        'Avaliador 1 Designado (Email)',
        'Avaliador 2 Designado (Nome)',
        'Avaliador 2 Designado (Email)',
        'Emails das Lideranças',
        'Processos Avaliados',
        'Status Validação',
        'Validado Por',
        'Data Validação',
      ]);

      // Processar cada formulário
      let processedForms = 0;
      for (const form of forms) {
        try {
          console.log(
            `📝 Processando formulário ${processedForms + 1}/${forms.length}: ${form.title}`
          );

          const formResponses = responses.filter(r => r.formId === form.id);

          // Obter avaliadores designados
          const avaliador1 = form.metadata?.avaliador1
            ? AVALIADORES.find(a => a.id === form.metadata.avaliador1)
            : null;
          const avaliador2 = form.metadata?.avaliador2
            ? AVALIADORES.find(a => a.id === form.metadata.avaliador2)
            : null;
          const designatedEvaluators = [
            form.metadata?.avaliador1,
            form.metadata?.avaliador2,
          ].filter(Boolean);

          // Se não há respostas, adicionar linha apenas com dados do formulário
          if (formResponses.length === 0) {
            for (const req of form.requirements || []) {
              detailedData.push([
                sanitizeForExcel(form.id),
                sanitizeForExcel(form.title),
                sanitizeForExcel(form.description),
                form.createdAt ? new Date(form.createdAt).toLocaleString('pt-BR') : '',
                form.lastModified ? new Date(form.lastModified).toLocaleString('pt-BR') : '',
                sanitizeForExcel(req.codigo),
                sanitizeForExcel(req.question),
                req.isEssential ? 'SIM' : 'NÃO',
                sanitizeForExcel(req.premissa),
                sanitizeForExcel(req.fontes),
                sanitizeForExcel(req.segmento),
                '', // ID Avaliador
                '', // Nome Avaliador
                '', // Email Avaliador
                '', // Level Avaliador
                '', // Avaliador Designado
                'Não respondido',
                '', // Data Resposta
                '', // Achados
                '', // Anexos Nome
                '', // Anexos Descrição
                '', // Anexos Validade
                '', // Anexos Status
                '', // Anexos URL
                '', // Anexos Tipo
                '', // Anexos Tamanho
                '', // Anexos Data
                sanitizeForExcel(
                  form.metadata?.unidadesOrganizacionais
                    ?.map(u => `${u.codigo} - ${u.nome}`)
                    .join('; ')
                ),
                sanitizeForExcel(
                  form.metadata?.unidadesOrganizacionais
                    ?.map(u => {
                      try {
                        return getUnidadeHierarchy(u.id);
                      } catch (e) {
                        return u.nome || '';
                      }
                    })
                    .join('; ')
                ),
                avaliador1?.nome || '',
                avaliador1?.login || '',
                avaliador2?.nome || '',
                avaliador2?.login || '',
                sanitizeForExcel(form.metadata?.emailsLiderancas?.join('; ') || ''),
                sanitizeForExcel(
                  form.metadata?.processosAvaliados?.map(p => `${p.nome} (${p.id})`).join(' | ') ||
                    ''
                ),
                '', // Status Validação
                '', // Validado Por
                '', // Data Validação
              ]);
            }
          } else {
            // Processar cada resposta
            for (const response of formResponses) {
              try {
                const isDesignated = designatedEvaluators.includes(response.avaliador?.id);

                for (const req of form.requirements || []) {
                  const answer =
                    response.answers?.[req.id] ||
                    response.answers?.[req.codigo] ||
                    'Não respondido';
                  const finding =
                    response.findings?.[req.id] || response.findings?.[req.codigo] || '';
                  const attachments =
                    response.attachments?.[req.id] || response.attachments?.[req.codigo] || [];

                  // Se não há anexos, adicionar uma linha
                  if (attachments.length === 0) {
                    detailedData.push([
                      sanitizeForExcel(form.id),
                      sanitizeForExcel(form.title),
                      sanitizeForExcel(form.description),
                      form.createdAt ? new Date(form.createdAt).toLocaleString('pt-BR') : '',
                      form.lastModified ? new Date(form.lastModified).toLocaleString('pt-BR') : '',
                      sanitizeForExcel(req.codigo),
                      sanitizeForExcel(req.question),
                      req.isEssential ? 'SIM' : 'NÃO',
                      sanitizeForExcel(req.premissa),
                      sanitizeForExcel(req.fontes),
                      sanitizeForExcel(req.segmento),
                      response.avaliador?.id || '',
                      response.avaliador?.nome || '',
                      response.avaliador?.email || response.avaliador?.login || '',
                      response.avaliador?.level || '',
                      isDesignated ? 'SIM' : 'NÃO',
                      answer === 'conforme'
                        ? 'Conforme'
                        : answer === 'nao-conforme'
                          ? 'Não Conforme'
                          : answer === 'nao-se-aplica'
                            ? 'Não se Aplica'
                            : 'Não respondido',
                      response.lastModified
                        ? new Date(response.lastModified).toLocaleString('pt-BR')
                        : '',
                      sanitizeForExcel(finding),
                      '', // Anexos Nome
                      '', // Anexos Descrição
                      '', // Anexos Validade
                      '', // Anexos Status
                      '', // Anexos URL
                      '', // Anexos Tipo
                      '', // Anexos Tamanho
                      '', // Anexos Data
                      sanitizeForExcel(
                        form.metadata?.unidadesOrganizacionais
                          ?.map(u => `${u.codigo} - ${u.nome}`)
                          .join('; ')
                      ),
                      sanitizeForExcel(
                        form.metadata?.unidadesOrganizacionais
                          ?.map(u => {
                            try {
                              return getUnidadeHierarchy(u.id);
                            } catch (e) {
                              return u.nome || '';
                            }
                          })
                          .join('; ')
                      ),
                      avaliador1?.nome || '',
                      avaliador1?.login || '',
                      avaliador2?.nome || '',
                      avaliador2?.login || '',
                      sanitizeForExcel(form.metadata?.emailsLiderancas?.join('; ') || ''),
                      sanitizeForExcel(
                        form.metadata?.processosAvaliados
                          ?.map(p => `${p.nome} (${p.id})`)
                          .join(' | ') || ''
                      ),
                      response && responseValidations[response.id] ? 'Validado' : 'Não Validado',
                      response && responseValidations[response.id]
                        ? responseValidations[response.id].validadoPor
                        : '',
                      response && responseValidations[response.id]
                        ? formatDate(responseValidations[response.id].dataValidacao)
                        : '',
                    ]);
                  } else {
                    // Adicionar uma linha para cada anexo
                    attachments.forEach((attachment, attachmentIdx) => {
                      let validityStatus = '';
                      try {
                        if (attachment.validityDate) {
                          validityStatus = isExpired(attachment.validityDate)
                            ? 'VENCIDO'
                            : isNearExpiry(attachment.validityDate)
                              ? 'PRÓXIMO DO VENCIMENTO'
                              : 'VÁLIDO';
                        }
                      } catch (e) {
                        console.warn('⚠️ Erro ao verificar validade do anexo:', e);
                      }

                      // Gerar URL permanente para o anexo
                      const attachmentUrl = getCleanAttachmentUrl(
                        attachment,
                        response.id, // ID da resposta
                        req.id || req.codigo, // ID da questão
                        attachmentIdx // Índice do anexo
                      );

                      detailedData.push([
                        sanitizeForExcel(form.id),
                        sanitizeForExcel(form.title),
                        sanitizeForExcel(form.description),
                        form.createdAt ? new Date(form.createdAt).toLocaleString('pt-BR') : '',
                        form.lastModified
                          ? new Date(form.lastModified).toLocaleString('pt-BR')
                          : '',
                        sanitizeForExcel(req.codigo),
                        sanitizeForExcel(req.question),
                        req.isEssential ? 'SIM' : 'NÃO',
                        sanitizeForExcel(req.premissa),
                        sanitizeForExcel(req.fontes),
                        sanitizeForExcel(req.segmento),
                        response.avaliador?.id || '',
                        response.avaliador?.nome || '',
                        response.avaliador?.email || response.avaliador?.login || '',
                        response.avaliador?.level || '',
                        isDesignated ? 'SIM' : 'NÃO',
                        answer === 'conforme'
                          ? 'Conforme'
                          : answer === 'nao-conforme'
                            ? 'Não Conforme'
                            : answer === 'nao-se-aplica'
                              ? 'Não se Aplica'
                              : 'Não respondido',
                        response.lastModified
                          ? new Date(response.lastModified).toLocaleString('pt-BR')
                          : '',
                        sanitizeForExcel(finding),
                        sanitizeForExcel(attachment.name),
                        sanitizeForExcel(attachment.description),
                        attachment.validityDate ? formatDate(attachment.validityDate) : '',
                        validityStatus,
                        attachmentUrl,
                        attachment.mimeType || '',
                        attachment.size ? `${(attachment.size / 1024).toFixed(2)} KB` : '',
                        attachment.createdAt
                          ? new Date(attachment.createdAt).toLocaleString('pt-BR')
                          : '',
                        sanitizeForExcel(
                          form.metadata?.unidadesOrganizacionais
                            ?.map(u => `${u.codigo} - ${u.nome}`)
                            .join('; ')
                        ),
                        sanitizeForExcel(
                          form.metadata?.unidadesOrganizacionais
                            ?.map(u => {
                              try {
                                return getUnidadeHierarchy(u.id);
                              } catch (e) {
                                return u.nome || '';
                              }
                            })
                            .join('; ')
                        ),
                        avaliador1?.nome || '',
                        avaliador1?.login || '',
                        avaliador2?.nome || '',
                        avaliador2?.login || '',
                        sanitizeForExcel(form.metadata?.emailsLiderancas?.join('; ') || ''),
                        sanitizeForExcel(
                          form.metadata?.processosAvaliados
                            ?.map(p => `${p.nome} (${p.id})`)
                            .join(' | ') || ''
                        ),
                        response && responseValidations[response.id] ? 'Validado' : 'Não Validado',
                        response && responseValidations[response.id]
                          ? responseValidations[response.id].validadoPor
                          : '',
                        response && responseValidations[response.id]
                          ? formatDate(responseValidations[response.id].dataValidacao)
                          : '',
                      ]);
                    });
                  }
                }
              } catch (responseError) {
                console.error(`❌ Erro ao processar resposta:`, responseError);
              }
            }
          }

          processedForms++;
        } catch (formError) {
          console.error(`❌ Erro ao processar formulário:`, formError);
        }
      }

      console.log(`✅ Processados ${processedForms}/${forms.length} formulários`);
      console.log(`📊 Total de linhas de dados: ${detailedData.length}`);

      // Criar aba de dados detalhados
      if (detailedData.length > 0) {
        const detailedSheet = XLSX.utils.aoa_to_sheet(detailedData);
        XLSX.utils.book_append_sheet(wb, detailedSheet, 'Dados Detalhados');
        console.log('✅ Aba Dados Detalhados criada');
      }

      // Continuar com as outras abas (simplificadas)...
      // [resto do código das outras abas permanece o mesmo, mas aplicar sanitizeForExcel em todos os campos de texto]

      // Gerar arquivo Excel
      console.log('📄 Gerando arquivo Excel...');
      const wbout = XLSX.write(wb, { type: 'base64', bookType: 'xlsx' });

      // Criar nome do arquivo
      const fileName = `backup_avaqualis_${new Date().toISOString().replace(/[:.]/g, '-').substring(0, 19)}.xlsx`;

      console.log(`📁 Nome do arquivo: ${fileName}`);

      if (Platform.OS === 'web') {
        // Código de download para web
        try {
          console.log('🌐 Criando download para web...');
          const binaryString = atob(wbout);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          console.log(`📦 Blob criado com tamanho: ${blob.size} bytes`);

          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();

          setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          }, 100);

          console.log('✅ Download iniciado com sucesso!');
          Alert.alert('✅ Sucesso', 'Backup baixado com sucesso!');
        } catch (webError) {
          console.error('❌ Erro no download web:', webError);
          throw webError;
        }
      } else {
        try {
          // Para mobile, salvar no sistema de arquivos e compartilhar
          console.log('📱 Salvando arquivo para mobile...');
          const fileUrl = FileSystem.documentDirectory + fileName;

          await FileSystem.writeAsStringAsync(fileUrl, wbout, {
            encoding: FileSystem.EncodingType.Base64,
          });

          console.log('📤 Compartilhando arquivo...');

          // Compartilhar arquivo
          await Sharing.shareAsync(fileUrl, {
            mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            dialogTitle: 'Salvar backup',
            UTI: 'com.microsoft.excel.xlsx',
          });

          console.log('✅ Arquivo compartilhado com sucesso!');
        } catch (mobileError) {
          console.error('❌ Erro no compartilhamento mobile:', mobileError);
          throw mobileError;
        }
      }

      // Adicione esta parte para limpar os blob URLs criados após um tempo
      setTimeout(() => {
        // Limpar todos os blob URLs criados durante a geração do Excel
        console.log('🧹 Limpando blob URLs temporários...');
        // Nota: Os blob URLs serão automaticamente liberados quando a aba for fechada
      }, 300000); // 5 minutos
    } catch (error) {
      console.error('❌ Erro ao gerar backup:', error);
      Alert.alert('❌ Erro', `Não foi possível gerar o backup.\n\nDetalhes: ${error.message}`);
    } finally {
      setDownloadingBackup(false);
    }
  };

  // MELHORADO: Renderização por formulário
  const renderByForm = () => {
    const filteredForms = getFilteredForms();

    return (
      <ScrollView
        showsVerticalScrollIndicator={false}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
      >
        {/* Análise Global */}
        <GlobalAnalysis forms={forms} responses={responses} selectedFormIds={selectedSubgroup} />

        {/* Seletor de Subgrupos */}
        <SubgroupSelector forms={forms} onSelectionChange={setSelectedSubgroup} />

        {filteredForms.map(form => {
          const formResponses = responses.filter(r => r.formId === form.id);
          const statistics = getFormStatistics(form.id, form.metadata);

          // Pular se há filtro de subgrupo e este form não está selecionado
          if (selectedSubgroup.length > 0 && !selectedSubgroup.includes(form.id)) {
            return null;
          }

          // Obter avaliadores designados
          const designatedEvaluators = [
            form.metadata?.avaliador1,
            form.metadata?.avaliador2,
          ].filter(Boolean);

          // Filtrar respostas autorizadas e não autorizadas
          const authorizedResponses = formResponses.filter(r =>
            designatedEvaluators.includes(r.avaliador?.id)
          );

          const unauthorizedResponses = formResponses.filter(
            r => r.avaliador && !designatedEvaluators.includes(r.avaliador?.id)
          );

          return (
            <Card key={form.id} style={styles.formCard}>
              <Card.Content>
                <View style={styles.formHeader}>
                  <View style={styles.formInfo}>
                    <Title style={styles.formTitle}>{form.title}</Title>
                    <Paragraph style={styles.formDescription} numberOfLines={2}>
                      {form.description}
                    </Paragraph>
                  </View>

                  {/* Botões de ação - APENAS PARA COORDENACAO/PROGRAMADOR */}
                  <View style={styles.formActions}>
                    {AuthService.canEditEvaluators() && (
                      <IconButton
                        icon="pencil"
                        size={24}
                        onPress={() => handleEditForm(form)}
                        style={styles.editButton}
                        iconColor={AVAQualisTheme.colors.primary}
                      />
                    )}

                    {AuthService.canDeleteForm() && (
                      <IconButton
                        icon="delete-forever"
                        size={24}
                        onPress={() => showDeleteOptions(form)}
                        style={styles.deleteButton}
                        iconColor="#D32F2F"
                      />
                    )}
                  </View>
                </View>
                {/* Badge de Validação */}
                {(() => {
                  // Verificar se alguma resposta deste formulário foi validada
                  const validatedResponse = formResponses.find(r => responseValidations[r.id]);
                  return validatedResponse ? (
                    <ValidationBadge validationInfo={responseValidations[validatedResponse.id]} />
                  ) : null;
                })()}
                {/* Progresso dos Avaliadores */}
                <EvaluatorProgress
                  formId={form.id}
                  formTitle={form.title}
                  evaluators={[]}
                  responses={formResponses}
                  metadata={form.metadata}
                  onDeleteResponse={deleteEvaluatorResponse}
                />

                {/* Estatísticas */}
                {statistics && statistics.totalQuestions > 0 && (
                  <View style={styles.statisticsContainer}>
                    <Text style={styles.statisticsTitle}>
                      📊 Estatísticas Consolidadas (apenas avaliadores designados):
                    </Text>
                    <View style={styles.statisticsGrid}>
                      <View style={styles.statItem}>
                        <Text style={styles.statValue}>{statistics.totalConforme}</Text>
                        <Text style={styles.statLabel}>Conforme</Text>
                      </View>
                      <View style={styles.statItem}>
                        <Text style={styles.statValue}>{statistics.totalNaoConforme}</Text>
                        <Text style={styles.statLabel}>Não Conforme</Text>
                      </View>
                      <View style={styles.statItem}>
                        <Text style={styles.statValue}>{statistics.totalNaoSeAplica}</Text>
                        <Text style={styles.statLabel}>Não se Aplica</Text>
                      </View>
                      <View style={styles.statItem}>
                        <Text style={[styles.statValue, styles.statValueHighlight]}>
                          {statistics.conformityRate}%
                        </Text>
                        <Text style={styles.statLabel}>Conformidade</Text>
                      </View>
                    </View>

                    {/* Sumário de Conformidade Detalhado */}
                    {authorizedResponses.length > 0 && (
                      <ConformitySummary
                        answers={Object.assign(
                          {},
                          ...authorizedResponses.map(r => r.answers || {})
                        )}
                        formId={form.id}
                        requirements={form.requirements}
                        excludeUnauthorized={true}
                        authorizedResponses={authorizedResponses}
                      />
                    )}
                  </View>
                )}

                {/* Respostas não autorizadas */}
                {unauthorizedResponses.length > 0 && (
                  <View style={styles.unauthorizedSection}>
                    <Text style={styles.unauthorizedSectionTitle}>
                      ⚠️ Respostas de avaliadores não designados ({unauthorizedResponses.length}):
                    </Text>
                    {unauthorizedResponses.map((response, index) => (
                      <TouchableOpacity
                        key={response.avaliador.id || index}
                        style={styles.unauthorizedItem}
                        onPress={() =>
                          handleViewUnauthorizedResponses(response.avaliador, [response], form)
                        }
                      >
                        <View style={styles.unauthorizedItemInfo}>
                          <Text style={styles.unauthorizedItemName}>{response.avaliador.nome}</Text>
                          <Text style={styles.unauthorizedItemLevel}>
                            {response.avaliador.level}
                          </Text>
                        </View>
                        <View style={styles.unauthorizedItemActions}>
                          <Badge style={styles.unauthorizedItemBadge}>
                            {Object.keys(response.answers || {}).length} respostas
                          </Badge>
                          {AuthService.canDeleteResponse(response, form) && (
                            <IconButton
                              icon="delete"
                              size={18}
                              iconColor="#F44336"
                              onPress={e => {
                                e.stopPropagation();
                                const responseId = response._id || response.id;
                                Alert.alert(
                                  '🗑️ Confirmar Exclusão',
                                  `Deseja realmente excluir o envio de ${response.avaliador.nome}?`,
                                  [
                                    { text: 'Cancelar', style: 'cancel' },
                                    {
                                      text: 'Excluir',
                                      style: 'destructive',
                                      onPress: () =>
                                        deleteEvaluatorResponse(responseId, response.avaliador),
                                    },
                                  ]
                                );
                              }}
                            />
                          )}
                        </View>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}

                {/* Botão para expandir requisitos */}
                {form.requirements && form.requirements.length > 0 && (
                  <Button
                    mode="outlined"
                    onPress={() => toggleExpanded(form.id)}
                    icon={expandedItems[form.id] ? 'chevron-up' : 'chevron-down'}
                    style={styles.expandButton}
                  >
                    {expandedItems[form.id] ? 'Ocultar' : 'Ver'} Requisitos Detalhados
                  </Button>
                )}

                {/* Lista de Requisitos Expandida */}
                {expandedItems[form.id] && form.requirements && (
                  <View style={styles.requirementsList}>
                    {form.requirements.map(requirement => (
                      <ConsolidatedResult
                        key={requirement.id}
                        requirement={requirement}
                        responses={formResponses}
                        evaluators={[]}
                        metadata={form.metadata}
                        expanded={expandedItems[`${form.id}-${requirement.id}`]}
                        onToggle={() => toggleExpanded(`${form.id}-${requirement.id}`)}
                      />
                    ))}
                  </View>
                )}
              </Card.Content>
            </Card>
          );
        })}

        {filteredForms.filter(f => selectedSubgroup.length === 0 || selectedSubgroup.includes(f.id))
          .length === 0 && (
          <Card style={styles.emptyCard}>
            <Card.Content>
              <View style={styles.emptyContent}>
                <MaterialCommunityIcons name="file-document-outline" size={48} color="#999" />
                <Text style={styles.emptyText}>
                  {searchQuery
                    ? 'Nenhum resultado encontrado'
                    : selectedSubgroup.length > 0
                      ? 'Nenhum formulário no subgrupo selecionado'
                      : 'Nenhum formulário disponível'}
                </Text>
              </View>
            </Card.Content>
          </Card>
        )}
      </ScrollView>
    );
  };

  // MELHORADO: Renderização por unidade com muito mais detalhes
  const renderByUnit = () => {
    // Agrupar por unidade organizacional
    const unitGroups = {};

    forms.forEach(form => {
      const units = form.metadata?.unidadesOrganizacionais || [];
      units.forEach(unit => {
        if (!unitGroups[unit.id]) {
          unitGroups[unit.id] = {
            unit,
            forms: [],
          };
        }
        unitGroups[unit.id].forms.push(form);
      });
    });

    return (
      <ScrollView
        showsVerticalScrollIndicator={false}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
      >
        {Object.values(unitGroups).map(group => {
          const unitAnalysis = getUnitDetailedAnalysis(group.unit, group.forms);

          return (
            <Card key={group.unit.id} style={styles.unitCard}>
              <Card.Content>
                <View style={styles.unitHeader}>
                  <View style={styles.unitInfo}>
                    <Text style={styles.unitCode}>{group.unit.codigo}</Text>
                    <Title style={styles.unitName}>{group.unit.nome}</Title>
                    <Text style={styles.unitHierarchy}>
                      🏗️ {getUnidadeHierarchy(group.unit.id)}
                    </Text>
                  </View>
                  <Badge style={styles.unitBadge}>{group.forms.length}</Badge>
                </View>

                <Divider style={styles.divider} />

                {/* Estatísticas Detalhadas da Unidade */}
                <View style={styles.unitDetailedStats}>
                  <Text style={styles.unitStatsTitle}>📊 Estatísticas Gerais da Unidade:</Text>

                  <View style={styles.unitStatsGrid}>
                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>{unitAnalysis.totalQuestions}</Text>
                      <Text style={styles.unitStatLabel}>Total Questões</Text>
                    </View>

                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>{unitAnalysis.percentConforme}%</Text>
                      <Text style={styles.unitStatLabel}>Conformidade Geral</Text>
                    </View>

                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>{unitAnalysis.percentConformeRE}%</Text>
                      <Text style={styles.unitStatLabel}>Conformidade RE</Text>
                    </View>

                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>
                        {unitAnalysis.attachmentsSummary.length}
                      </Text>
                      <Text style={styles.unitStatLabel}>Total Anexos</Text>
                    </View>
                  </View>

                  {/* Detalhamento de Conformidade */}
                  <View style={styles.unitConformityDetails}>
                    <View style={styles.unitConformityRow}>
                      <Text style={styles.unitConformityLabel}>✅ Conforme:</Text>
                      <Text style={styles.unitConformityValue}>
                        {unitAnalysis.unitConforme} ({unitAnalysis.percentConforme}%)
                      </Text>
                    </View>

                    <View style={styles.unitConformityRow}>
                      <Text style={styles.unitConformityLabel}>❌ Não Conforme:</Text>
                      <Text style={styles.unitConformityValue}>
                        {unitAnalysis.unitNaoConforme} ({unitAnalysis.percentNaoConforme}%)
                      </Text>
                    </View>

                    <View style={styles.unitConformityRow}>
                      <Text style={styles.unitConformityLabel}>➖ Não se Aplica:</Text>
                      <Text style={styles.unitConformityValue}>{unitAnalysis.unitNaoSeAplica}</Text>
                    </View>
                  </View>

                  {/* Requisitos Essenciais */}
                  {(unitAnalysis.unitConformeRE > 0 || unitAnalysis.unitNaoConformeRE > 0) && (
                    <View style={styles.unitRESection}>
                      <Text style={styles.unitRESectionTitle}>⚠️ Requisitos Essenciais:</Text>
                      <View style={styles.unitREGrid}>
                        <View style={styles.unitREItem}>
                          <Text style={styles.unitREValue}>
                            {unitAnalysis.unitConformeRE} ({unitAnalysis.percentConformeRE}%)
                          </Text>
                          <Text style={styles.unitRELabel}>Conforme</Text>
                        </View>

                        <View style={styles.unitREItem}>
                          <Text style={styles.unitREValue}>
                            {unitAnalysis.unitNaoConformeRE} ({unitAnalysis.percentNaoConformeRE}%)
                          </Text>
                          <Text style={styles.unitRELabel}>Não Conforme</Text>
                        </View>
                      </View>
                    </View>
                  )}
                </View>

                <Divider style={styles.divider} />

                {/* Detalhes por Avaliador */}
                <View style={styles.unitEvaluatorSection}>
                  <Text style={styles.unitEvaluatorTitle}>👥 Detalhamento por Avaliador:</Text>

                  {Object.values(unitAnalysis.evaluatorDetails).map((evaluatorDetail, index) => (
                    <View key={evaluatorDetail.email || index} style={styles.unitEvaluatorCard}>
                      <View style={styles.unitEvaluatorHeader}>
                        <View style={styles.unitEvaluatorInfo}>
                          <Text style={styles.unitEvaluatorName}>{evaluatorDetail.nome}</Text>
                          <Text style={styles.unitEvaluatorEmail}>{evaluatorDetail.email}</Text>
                          <Chip mode="flat" compact style={styles.unitEvaluatorChip}>
                            {evaluatorDetail.level}
                          </Chip>
                        </View>
                        <View style={styles.unitEvaluatorStats}>
                          <Text style={styles.unitEvaluatorStatValue}>
                            {evaluatorDetail.totalRespostas}
                          </Text>
                          <Text style={styles.unitEvaluatorStatLabel}>Respostas</Text>
                        </View>
                      </View>

                      <View style={styles.unitEvaluatorResults}>
                        <View style={styles.unitEvaluatorResultItem}>
                          <Text style={styles.unitEvaluatorResultIcon}>✅</Text>
                          <Text style={styles.unitEvaluatorResultText}>
                            {evaluatorDetail.conforme} (
                            {evaluatorDetail.totalRespostas > 0
                              ? (
                                  (evaluatorDetail.conforme / evaluatorDetail.totalRespostas) *
                                  100
                                ).toFixed(0)
                              : 0}
                            %)
                          </Text>
                        </View>

                        <View style={styles.unitEvaluatorResultItem}>
                          <Text style={styles.unitEvaluatorResultIcon}>❌</Text>
                          <Text style={styles.unitEvaluatorResultText}>
                            {evaluatorDetail.naoConforme} (
                            {evaluatorDetail.totalRespostas > 0
                              ? (
                                  (evaluatorDetail.naoConforme / evaluatorDetail.totalRespostas) *
                                  100
                                ).toFixed(0)
                              : 0}
                            %)
                          </Text>
                        </View>

                        <View style={styles.unitEvaluatorResultItem}>
                          <Text style={styles.unitEvaluatorResultIcon}>➖</Text>
                          <Text style={styles.unitEvaluatorResultText}>
                            {evaluatorDetail.naoSeAplica} (
                            {evaluatorDetail.totalRespostas > 0
                              ? (
                                  (evaluatorDetail.naoSeAplica / evaluatorDetail.totalRespostas) *
                                  100
                                ).toFixed(0)
                              : 0}
                            %)
                          </Text>
                        </View>
                      </View>

                      {/* Anexos do Avaliador */}
                      {evaluatorDetail.attachments.length > 0 && (
                        <TouchableOpacity
                          style={styles.unitEvaluatorAttachmentsButton}
                          onPress={() =>
                            toggleExpanded(
                              `unit-evaluator-attachments-${group.unit.id}-${evaluatorDetail.email}`
                            )
                          }
                        >
                          <Text style={styles.unitEvaluatorAttachmentsText}>
                            📎 {evaluatorDetail.attachments.length} anexo(s)
                          </Text>
                          <MaterialCommunityIcons
                            name={
                              expandedItems[
                                `unit-evaluator-attachments-${group.unit.id}-${evaluatorDetail.email}`
                              ]
                                ? 'chevron-up'
                                : 'chevron-down'
                            }
                            size={20}
                            color="#666"
                          />
                        </TouchableOpacity>
                      )}

                      {expandedItems[
                        `unit-evaluator-attachments-${group.unit.id}-${evaluatorDetail.email}`
                      ] && (
                        <View style={styles.unitEvaluatorAttachmentsList}>
                          {evaluatorDetail.attachments.map((attachment, idx) => (
                            <TouchableOpacity
                              key={idx}
                              style={styles.unitAttachmentItem}
                              onPress={() => handleOpenAttachment(attachment)}
                            >
                              <View style={styles.unitAttachmentIcon}>
                                <Text style={styles.unitAttachmentEmoji}>
                                  {getFileEmoji(attachment.mimeType, attachment.name)}
                                </Text>
                              </View>
                              <View style={styles.unitAttachmentContent}>
                                <Text style={styles.unitAttachmentName} numberOfLines={1}>
                                  {attachment.name || 'Anexo'}
                                </Text>
                                <Text style={styles.unitAttachmentFormTitle} numberOfLines={1}>
                                  📋 {attachment.formTitle}
                                </Text>
                                <Text style={styles.unitAttachmentRequirement} numberOfLines={1}>
                                  📌 {attachment.requirementCode}: {attachment.requirementQuestion}
                                </Text>
                                {attachment.description && (
                                  <Text style={styles.unitAttachmentDescription} numberOfLines={2}>
                                    💬 {attachment.description}
                                  </Text>
                                )}
                                {attachment.validityDate && (
                                  <Text
                                    style={[
                                      styles.unitAttachmentValidity,
                                      isExpired(attachment.validityDate) &&
                                        styles.attachmentValidityExpired,
                                      isNearExpiry(attachment.validityDate) &&
                                        styles.attachmentValidityWarning,
                                    ]}
                                  >
                                    📅 Válido até: {formatDate(attachment.validityDate)}
                                    {isExpired(attachment.validityDate) && ' (VENCIDO)'}
                                    {isNearExpiry(attachment.validityDate) &&
                                      !isExpired(attachment.validityDate) &&
                                      ' (PRÓX. VENCIMENTO)'}
                                  </Text>
                                )}
                              </View>
                              <MaterialCommunityIcons name="open-in-new" size={20} color="#666" />
                            </TouchableOpacity>
                          ))}
                        </View>
                      )}
                    </View>
                  ))}
                </View>

                <Divider style={styles.divider} />

                {/* Lista de Formulários da Unidade */}
                <View style={styles.unitFormsList}>
                  <Text style={styles.unitFormsTitle}>📋 Formulários da Unidade:</Text>

                  {group.forms.map(form => {
                    const formResponses = responses.filter(r => r.formId === form.id);
                    const statistics = getFormStatistics(form.id, form.metadata);

                    return (
                      <TouchableOpacity
                        key={form.id}
                        style={styles.unitFormItem}
                        onPress={() => toggleExpanded(`unit-${group.unit.id}-${form.id}`)}
                      >
                        <View style={styles.unitFormHeader}>
                          <View style={styles.unitFormTitleContainer}>
                            <Text style={styles.unitFormTitle}>{form.title}</Text>
                            <Text style={styles.unitFormDescription} numberOfLines={1}>
                              {form.description}
                            </Text>
                          </View>
                          {statistics && (
                            <Chip
                              mode="flat"
                              compact
                              style={[
                                styles.conformityChip,
                                statistics.conformityRate >= 80 && styles.conformityChipGood,
                                statistics.conformityRate < 50 && styles.conformityChipBad,
                              ]}
                            >
                              {statistics.conformityRate}%
                            </Chip>
                          )}
                        </View>

                        {expandedItems[`unit-${group.unit.id}-${form.id}`] && (
                          <View style={styles.unitFormDetails}>
                            <View style={styles.unitFormStatsGrid}>
                              <View style={styles.unitFormStatItem}>
                                <Text style={styles.unitFormStatLabel}>Total Requisitos:</Text>
                                <Text style={styles.unitFormStatValue}>{form.totalQuestions}</Text>
                              </View>

                              {statistics && (
                                <>
                                  <View style={styles.unitFormStatItem}>
                                    <Text style={styles.unitFormStatLabel}>✅ Conforme:</Text>
                                    <Text style={styles.unitFormStatValue}>
                                      {statistics.totalConforme}
                                    </Text>
                                  </View>

                                  <View style={styles.unitFormStatItem}>
                                    <Text style={styles.unitFormStatLabel}>❌ Não Conforme:</Text>
                                    <Text style={styles.unitFormStatValue}>
                                      {statistics.totalNaoConforme}
                                    </Text>
                                  </View>

                                  <View style={styles.unitFormStatItem}>
                                    <Text style={styles.unitFormStatLabel}>➖ Não se Aplica:</Text>
                                    <Text style={styles.unitFormStatValue}>
                                      {statistics.totalNaoSeAplica}
                                    </Text>
                                  </View>
                                </>
                              )}
                            </View>

                            {/* Avaliadores do Formulário */}
                            <View style={styles.unitFormEvaluators}>
                              <Text style={styles.unitFormEvaluatorsTitle}>
                                Avaliadores Designados:
                              </Text>
                              <Text style={styles.unitFormEvaluatorName}>
                                1️⃣{' '}
                                {form.metadata?.avaliador1
                                  ? AVALIADORES.find(a => a.id === form.metadata.avaliador1)?.nome
                                  : 'Não designado'}
                              </Text>
                              <Text style={styles.unitFormEvaluatorName}>
                                2️⃣{' '}
                                {form.metadata?.avaliador2
                                  ? AVALIADORES.find(a => a.id === form.metadata.avaliador2)?.nome
                                  : 'Não designado'}
                              </Text>
                            </View>

                            {/* Botão para ver detalhes completos */}
                            <Button
                              mode="outlined"
                              onPress={() =>
                                toggleExpanded(`unit-form-details-${group.unit.id}-${form.id}`)
                              }
                              icon="eye"
                              compact
                              style={styles.unitFormDetailsButton}
                            >
                              Ver Requisitos Detalhados
                            </Button>

                            {/* Requisitos Detalhados */}
                            {expandedItems[`unit-form-details-${group.unit.id}-${form.id}`] && (
                              <View style={styles.unitFormRequirements}>
                                {form.requirements?.map(requirement => (
                                  <ConsolidatedResult
                                    key={requirement.id}
                                    requirement={requirement}
                                    responses={formResponses}
                                    evaluators={[]}
                                    metadata={form.metadata}
                                    expanded={
                                      expandedItems[
                                        `unit-req-${group.unit.id}-${form.id}-${requirement.id}`
                                      ]
                                    }
                                    onToggle={() =>
                                      toggleExpanded(
                                        `unit-req-${group.unit.id}-${form.id}-${requirement.id}`
                                      )
                                    }
                                  />
                                ))}
                              </View>
                            )}
                          </View>
                        )}
                      </TouchableOpacity>
                    );
                  })}
                </View>
              </Card.Content>
            </Card>
          );
        })}

        {Object.keys(unitGroups).length === 0 && (
          <Card style={styles.emptyCard}>
            <Card.Content>
              <View style={styles.emptyContent}>
                <MaterialCommunityIcons name="office-building" size={48} color="#999" />
                <Text style={styles.emptyText}>Nenhuma unidade organizacional encontrada</Text>
              </View>
            </Card.Content>
          </Card>
        )}
      </ScrollView>
    );
  };

  // NOVO: Renderização por processo
  const renderByProcess = () => {
    // Agrupar por processo
    const processGroups = {};

    forms.forEach(form => {
      const processos =
        form.metadata?.processosAvaliados ||
        (form.metadata?.processoAvaliado ? [form.metadata.processoAvaliado] : []);

      processos.forEach(processo => {
        if (!processGroups[processo.id]) {
          processGroups[processo.id] = {
            processo,
            forms: [],
          };
        }
        processGroups[processo.id].forms.push(form);
      });
    });

    // Ordenar por nome do processo
    const sortedProcessGroups = Object.values(processGroups).sort((a, b) =>
      a.processo.nome.localeCompare(b.processo.nome, 'pt-BR')
    );

    return (
      <ScrollView
        showsVerticalScrollIndicator={false}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
      >
        {sortedProcessGroups.map(group => {
          const processAnalysis = getProcessDetailedAnalysis(group.processo, group.forms);

          return (
            <Card key={group.processo.id} style={styles.unitCard}>
              <Card.Content>
                <View style={styles.unitHeader}>
                  <View style={styles.unitInfo}>
                    <Text style={styles.unitCode}>⚙️ {group.processo.id}</Text>
                    <Title style={styles.unitName}>{group.processo.nome}</Title>
                    <Text style={styles.unitHierarchy}>
                      📋 Processo avaliado em {group.forms.length} formulário
                      {group.forms.length !== 1 ? 's' : ''}
                    </Text>
                  </View>
                  <Badge style={styles.unitBadge}>{group.forms.length}</Badge>
                </View>

                <Divider style={styles.divider} />

                {/* Estatísticas Detalhadas do Processo */}
                <View style={styles.unitDetailedStats}>
                  <Text style={styles.unitStatsTitle}>📊 Estatísticas Gerais do Processo:</Text>

                  <View style={styles.unitStatsGrid}>
                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>{processAnalysis.totalQuestions}</Text>
                      <Text style={styles.unitStatLabel}>Total Questões</Text>
                    </View>

                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>{processAnalysis.percentConforme}%</Text>
                      <Text style={styles.unitStatLabel}>Conformidade Geral</Text>
                    </View>

                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>{processAnalysis.percentConformeRE}%</Text>
                      <Text style={styles.unitStatLabel}>Conformidade RE</Text>
                    </View>

                    <View style={styles.unitStatItem}>
                      <Text style={styles.unitStatValue}>
                        {processAnalysis.attachmentsSummary.length}
                      </Text>
                      <Text style={styles.unitStatLabel}>Total Anexos</Text>
                    </View>
                  </View>

                  {/* Detalhamento de Conformidade */}
                  <View style={styles.unitConformityDetails}>
                    <View style={styles.unitConformityRow}>
                      <Text style={styles.unitConformityLabel}>✅ Conforme:</Text>
                      <Text style={styles.unitConformityValue}>
                        {processAnalysis.processConforme} ({processAnalysis.percentConforme}%)
                      </Text>
                    </View>

                    <View style={styles.unitConformityRow}>
                      <Text style={styles.unitConformityLabel}>❌ Não Conforme:</Text>
                      <Text style={styles.unitConformityValue}>
                        {processAnalysis.processNaoConforme} ({processAnalysis.percentNaoConforme}%)
                      </Text>
                    </View>

                    <View style={styles.unitConformityRow}>
                      <Text style={styles.unitConformityLabel}>➖ Não se Aplica:</Text>
                      <Text style={styles.unitConformityValue}>
                        {processAnalysis.processNaoSeAplica}
                      </Text>
                    </View>
                  </View>

                  {/* Requisitos Essenciais */}
                  {(processAnalysis.processConformeRE > 0 ||
                    processAnalysis.processNaoConformeRE > 0) && (
                    <View style={styles.unitRESection}>
                      <Text style={styles.unitRESectionTitle}>⚠️ Requisitos Essenciais:</Text>
                      <View style={styles.unitREGrid}>
                        <View style={styles.unitREItem}>
                          <Text style={styles.unitREValue}>
                            {processAnalysis.processConformeRE} ({processAnalysis.percentConformeRE}
                            %)
                          </Text>
                          <Text style={styles.unitRELabel}>Conforme</Text>
                        </View>

                        <View style={styles.unitREItem}>
                          <Text style={styles.unitREValue}>
                            {processAnalysis.processNaoConformeRE} (
                            {processAnalysis.percentNaoConformeRE}%)
                          </Text>
                          <Text style={styles.unitRELabel}>Não Conforme</Text>
                        </View>
                      </View>
                    </View>
                  )}
                </View>

                <Divider style={styles.divider} />

                {/* Detalhes por Avaliador */}
                <View style={styles.unitEvaluatorSection}>
                  <Text style={styles.unitEvaluatorTitle}>👥 Detalhamento por Avaliador:</Text>

                  {Object.values(processAnalysis.evaluatorDetails).map((evaluatorDetail, index) => (
                    <View key={evaluatorDetail.email || index} style={styles.unitEvaluatorCard}>
                      <View style={styles.unitEvaluatorHeader}>
                        <View style={styles.unitEvaluatorInfo}>
                          <Text style={styles.unitEvaluatorName}>{evaluatorDetail.nome}</Text>
                          <Text style={styles.unitEvaluatorEmail}>{evaluatorDetail.email}</Text>
                          <Chip mode="flat" compact style={styles.unitEvaluatorChip}>
                            {evaluatorDetail.level}
                          </Chip>
                        </View>
                        <View style={styles.unitEvaluatorStats}>
                          <Text style={styles.unitEvaluatorStatValue}>
                            {evaluatorDetail.totalRespostas}
                          </Text>
                          <Text style={styles.unitEvaluatorStatLabel}>Respostas</Text>
                        </View>
                      </View>

                      <View style={styles.unitEvaluatorResults}>
                        <View style={styles.unitEvaluatorResultItem}>
                          <Text style={styles.unitEvaluatorResultIcon}>✅</Text>
                          <Text style={styles.unitEvaluatorResultText}>
                            {evaluatorDetail.conforme} (
                            {evaluatorDetail.totalRespostas > 0
                              ? (
                                  (evaluatorDetail.conforme / evaluatorDetail.totalRespostas) *
                                  100
                                ).toFixed(0)
                              : 0}
                            %)
                          </Text>
                        </View>

                        <View style={styles.unitEvaluatorResultItem}>
                          <Text style={styles.unitEvaluatorResultIcon}>❌</Text>
                          <Text style={styles.unitEvaluatorResultText}>
                            {evaluatorDetail.naoConforme} (
                            {evaluatorDetail.totalRespostas > 0
                              ? (
                                  (evaluatorDetail.naoConforme / evaluatorDetail.totalRespostas) *
                                  100
                                ).toFixed(0)
                              : 0}
                            %)
                          </Text>
                        </View>

                        <View style={styles.unitEvaluatorResultItem}>
                          <Text style={styles.unitEvaluatorResultIcon}>➖</Text>
                          <Text style={styles.unitEvaluatorResultText}>
                            {evaluatorDetail.naoSeAplica} (
                            {evaluatorDetail.totalRespostas > 0
                              ? (
                                  (evaluatorDetail.naoSeAplica / evaluatorDetail.totalRespostas) *
                                  100
                                ).toFixed(0)
                              : 0}
                            %)
                          </Text>
                        </View>
                      </View>

                      {/* Anexos do Avaliador */}
                      {evaluatorDetail.attachments.length > 0 && (
                        <TouchableOpacity
                          style={styles.unitEvaluatorAttachmentsButton}
                          onPress={() =>
                            toggleExpanded(
                              `process-evaluator-attachments-${group.processo.id}-${evaluatorDetail.email}`
                            )
                          }
                        >
                          <Text style={styles.unitEvaluatorAttachmentsText}>
                            📎 {evaluatorDetail.attachments.length} anexo(s)
                          </Text>
                          <MaterialCommunityIcons
                            name={
                              expandedItems[
                                `process-evaluator-attachments-${group.processo.id}-${evaluatorDetail.email}`
                              ]
                                ? 'chevron-up'
                                : 'chevron-down'
                            }
                            size={20}
                            color="#666"
                          />
                        </TouchableOpacity>
                      )}

                      {expandedItems[
                        `process-evaluator-attachments-${group.processo.id}-${evaluatorDetail.email}`
                      ] && (
                        <View style={styles.unitEvaluatorAttachmentsList}>
                          {evaluatorDetail.attachments.map((attachment, idx) => (
                            <TouchableOpacity
                              key={idx}
                              style={styles.unitAttachmentItem}
                              onPress={() => handleOpenAttachment(attachment)}
                            >
                              <View style={styles.unitAttachmentIcon}>
                                <Text style={styles.unitAttachmentEmoji}>
                                  {getFileEmoji(attachment.mimeType, attachment.name)}
                                </Text>
                              </View>
                              <View style={styles.unitAttachmentContent}>
                                <Text style={styles.unitAttachmentName} numberOfLines={1}>
                                  {attachment.name || 'Anexo'}
                                </Text>
                                <Text style={styles.unitAttachmentFormTitle} numberOfLines={1}>
                                  📋 {attachment.formTitle}
                                </Text>
                                <Text style={styles.unitAttachmentRequirement} numberOfLines={1}>
                                  📌 {attachment.requirementCode}: {attachment.requirementQuestion}
                                </Text>
                                {attachment.description && (
                                  <Text style={styles.unitAttachmentDescription} numberOfLines={2}>
                                    💬 {attachment.description}
                                  </Text>
                                )}
                                {attachment.validityDate && (
                                  <Text
                                    style={[
                                      styles.unitAttachmentValidity,
                                      isExpired(attachment.validityDate) &&
                                        styles.attachmentValidityExpired,
                                      isNearExpiry(attachment.validityDate) &&
                                        styles.attachmentValidityWarning,
                                    ]}
                                  >
                                    📅 Válido até: {formatDate(attachment.validityDate)}
                                    {isExpired(attachment.validityDate) && ' (VENCIDO)'}
                                    {isNearExpiry(attachment.validityDate) &&
                                      !isExpired(attachment.validityDate) &&
                                      ' (PRÓX. VENCIMENTO)'}
                                  </Text>
                                )}
                              </View>
                              <MaterialCommunityIcons name="open-in-new" size={20} color="#666" />
                            </TouchableOpacity>
                          ))}
                        </View>
                      )}
                    </View>
                  ))}
                </View>

                <Divider style={styles.divider} />

                {/* Lista de Formulários do Processo */}
                <View style={styles.unitFormsList}>
                  <Text style={styles.unitFormsTitle}>📋 Formulários deste Processo:</Text>

                  {group.forms.map(form => {
                    const formResponses = responses.filter(r => r.formId === form.id);
                    const statistics = getFormStatistics(form.id, form.metadata);

                    return (
                      <TouchableOpacity
                        key={form.id}
                        style={styles.unitFormItem}
                        onPress={() => toggleExpanded(`process-${group.processo.id}-${form.id}`)}
                      >
                        <View style={styles.unitFormHeader}>
                          <View style={styles.unitFormTitleContainer}>
                            <Text style={styles.unitFormTitle}>{form.title}</Text>
                            <Text style={styles.unitFormDescription} numberOfLines={1}>
                              {form.description}
                            </Text>
                          </View>
                          {statistics && (
                            <Chip
                              mode="flat"
                              compact
                              style={[
                                styles.conformityChip,
                                statistics.conformityRate >= 80 && styles.conformityChipGood,
                                statistics.conformityRate < 50 && styles.conformityChipBad,
                              ]}
                            >
                              {statistics.conformityRate}%
                            </Chip>
                          )}
                        </View>

                        {expandedItems[`process-${group.processo.id}-${form.id}`] && (
                          <View style={styles.unitFormDetails}>
                            <View style={styles.unitFormStatsGrid}>
                              <View style={styles.unitFormStatItem}>
                                <Text style={styles.unitFormStatLabel}>Total Requisitos:</Text>
                                <Text style={styles.unitFormStatValue}>{form.totalQuestions}</Text>
                              </View>

                              {statistics && (
                                <>
                                  <View style={styles.unitFormStatItem}>
                                    <Text style={styles.unitFormStatLabel}>✅ Conforme:</Text>
                                    <Text style={styles.unitFormStatValue}>
                                      {statistics.totalConforme}
                                    </Text>
                                  </View>

                                  <View style={styles.unitFormStatItem}>
                                    <Text style={styles.unitFormStatLabel}>❌ Não Conforme:</Text>
                                    <Text style={styles.unitFormStatValue}>
                                      {statistics.totalNaoConforme}
                                    </Text>
                                  </View>

                                  <View style={styles.unitFormStatItem}>
                                    <Text style={styles.unitFormStatLabel}>➖ Não se Aplica:</Text>
                                    <Text style={styles.unitFormStatValue}>
                                      {statistics.totalNaoSeAplica}
                                    </Text>
                                  </View>
                                </>
                              )}
                            </View>

                            {/* Avaliadores do Formulário */}
                            <View style={styles.unitFormEvaluators}>
                              <Text style={styles.unitFormEvaluatorsTitle}>
                                Avaliadores Designados:
                              </Text>
                              <Text style={styles.unitFormEvaluatorName}>
                                1️⃣{' '}
                                {form.metadata?.avaliador1
                                  ? AVALIADORES.find(a => a.id === form.metadata.avaliador1)?.nome
                                  : 'Não designado'}
                              </Text>
                              <Text style={styles.unitFormEvaluatorName}>
                                2️⃣{' '}
                                {form.metadata?.avaliador2
                                  ? AVALIADORES.find(a => a.id === form.metadata.avaliador2)?.nome
                                  : 'Não designado'}
                              </Text>
                            </View>

                            {/* Botão para ver detalhes completos */}
                            <Button
                              mode="outlined"
                              onPress={() =>
                                toggleExpanded(
                                  `process-form-details-${group.processo.id}-${form.id}`
                                )
                              }
                              icon="eye"
                              compact
                              style={styles.unitFormDetailsButton}
                            >
                              Ver Requisitos Detalhados
                            </Button>

                            {/* Requisitos Detalhados */}
                            {expandedItems[
                              `process-form-details-${group.processo.id}-${form.id}`
                            ] && (
                              <View style={styles.unitFormRequirements}>
                                {form.requirements?.map(requirement => (
                                  <ConsolidatedResult
                                    key={requirement.id}
                                    requirement={requirement}
                                    responses={formResponses}
                                    evaluators={[]}
                                    metadata={form.metadata}
                                    expanded={
                                      expandedItems[
                                        `process-req-${group.processo.id}-${form.id}-${requirement.id}`
                                      ]
                                    }
                                    onToggle={() =>
                                      toggleExpanded(
                                        `process-req-${group.processo.id}-${form.id}-${requirement.id}`
                                      )
                                    }
                                  />
                                ))}
                              </View>
                            )}
                          </View>
                        )}
                      </TouchableOpacity>
                    );
                  })}
                </View>
              </Card.Content>
            </Card>
          );
        })}

        {Object.keys(processGroups).length === 0 && (
          <Card style={styles.emptyCard}>
            <Card.Content>
              <View style={styles.emptyContent}>
                <MaterialCommunityIcons name="cog-outline" size={48} color="#999" />
                <Text style={styles.emptyText}>Nenhum processo avaliado encontrado</Text>
              </View>
            </Card.Content>
          </Card>
        )}
      </ScrollView>
    );
  };

  // MELHORADO: Renderização por requisito com mais detalhes
  const renderByRequirement = () => {
    // Agrupar todos os requisitos únicos
    const requirementGroups = {};

    forms.forEach(form => {
      (form.requirements || []).forEach(req => {
        const key = req.codigo || req.id;
        if (!requirementGroups[key]) {
          requirementGroups[key] = {
            requirement: req,
            forms: [],
          };
        }
        requirementGroups[key].forms.push({
          form,
          responses: responses.filter(r => r.formId === form.id),
        });
      });
    });

    // Ordenar requisitos por código
    const sortedRequirements = Object.values(requirementGroups).sort((a, b) => {
      const codeA = (a.requirement.codigo || '').split('.').map(n => parseInt(n) || 0);
      const codeB = (b.requirement.codigo || '').split('.').map(n => parseInt(n) || 0);

      for (let i = 0; i < Math.max(codeA.length, codeB.length); i++) {
        const numA = codeA[i] || 0;
        const numB = codeB[i] || 0;
        if (numA !== numB) return numA - numB;
      }
      return 0;
    });

    return (
      <ScrollView
        showsVerticalScrollIndicator={false}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
      >
        {sortedRequirements.map(group => {
          // Calcular estatísticas agregadas do requisito (apenas designados)
          let totalConforme = 0;
          let totalNaoConforme = 0;
          let totalNaoSeAplica = 0;
          let totalOccurrences = 0;
          let evaluatorSummary = {};
          let attachmentsByRequirement = [];

          group.forms.forEach(({ form, responses: formResponses }) => {
            if (formResponses.length > 0) {
              // Obter avaliadores designados
              const designatedEvaluators = [
                form.metadata?.avaliador1,
                form.metadata?.avaliador2,
              ].filter(Boolean);

              // Filtrar apenas respostas dos avaliadores designados
              const authorizedResponses = formResponses.filter(r =>
                designatedEvaluators.includes(r.avaliador?.id)
              );

              const allAnswers = [];
              authorizedResponses.forEach(resp => {
                const answer =
                  resp.answers?.[group.requirement.id] || resp.answers?.[group.requirement.codigo];
                const finding =
                  resp.findings?.[group.requirement.id] ||
                  resp.findings?.[group.requirement.codigo];
                const attachments =
                  resp.attachments?.[group.requirement.id] ||
                  resp.attachments?.[group.requirement.codigo] ||
                  [];

                if (answer) {
                  allAnswers.push(answer);

                  // Registrar informações do avaliador
                  if (!evaluatorSummary[resp.avaliador.id]) {
                    evaluatorSummary[resp.avaliador.id] = {
                      nome: resp.avaliador.nome,
                      email: resp.avaliador.email || resp.avaliador.login,
                      level: resp.avaliador.level,
                      responses: [],
                    };
                  }

                  evaluatorSummary[resp.avaliador.id].responses.push({
                    formTitle: form.title,
                    unitName: form.metadata?.unidadesOrganizacionais?.[0]?.nome || '',
                    answer,
                    finding,
                    attachments: attachments.map(att => ({
                      ...att,
                      formTitle: form.title,
                      avaliadorNome: resp.avaliador.nome,
                    })),
                  });

                  // Coletar anexos
                  attachments.forEach(att => {
                    attachmentsByRequirement.push({
                      ...att,
                      formTitle: form.title,
                      unitName: form.metadata?.unidadesOrganizacionais?.[0]?.nome || '',
                      avaliadorNome: resp.avaliador.nome,
                      avaliadorId: resp.avaliador.id,
                    });
                  });
                }
              });

              if (allAnswers.length > 0) {
                totalOccurrences++;

                // Determinar resultado consolidado
                let result;
                if (allAnswers.every(a => a === allAnswers[0])) {
                  result = allAnswers[0];
                } else if (allAnswers.some(a => a === 'nao-conforme')) {
                  result = 'nao-conforme';
                } else if (allAnswers.some(a => a === 'conforme')) {
                  result = 'conforme';
                } else {
                  result = 'nao-se-aplica';
                }

                switch (result) {
                  case 'conforme':
                    totalConforme++;
                    break;
                  case 'nao-conforme':
                    totalNaoConforme++;
                    break;
                  case 'nao-se-aplica':
                    totalNaoSeAplica++;
                    break;
                }
              }
            }
          });

          const conformityRate =
            totalConforme + totalNaoConforme > 0
              ? Math.round((totalConforme / (totalConforme + totalNaoConforme)) * 100)
              : 0;

          return (
            <Card
              key={group.requirement.codigo || group.requirement.id}
              style={styles.requirementCard}
            >
              <TouchableOpacity
                onPress={() =>
                  toggleExpanded(`req-${group.requirement.codigo || group.requirement.id}`)
                }
              >
                <Card.Content>
                  <View style={styles.requirementHeader}>
                    <View style={styles.requirementInfo}>
                      <View style={styles.requirementCodeRow}>
                        <Chip mode="outlined" compact style={styles.codeChip}>
                          {group.requirement.codigo}
                        </Chip>
                        {group.requirement.isEssential && (
                          <Badge style={styles.essentialBadge}>RE</Badge>
                        )}
                      </View>
                      <Text style={styles.requirementText} numberOfLines={2}>
                        {group.requirement.question}
                      </Text>
                    </View>
                    <View style={styles.requirementStats}>
                      <Text style={styles.occurrencesText}>{group.forms.length} formulário(s)</Text>
                      {totalOccurrences > 0 && (
                        <Chip
                          mode="flat"
                          compact
                          style={[
                            styles.conformityChip,
                            conformityRate >= 80 && styles.conformityChipGood,
                            conformityRate < 50 && styles.conformityChipBad,
                          ]}
                        >
                          {conformityRate}%
                        </Chip>
                      )}
                    </View>
                  </View>

                  {expandedItems[`req-${group.requirement.codigo || group.requirement.id}`] && (
                    <>
                      <Divider style={styles.divider} />

                      {/* Estatísticas agregadas */}
                      {totalOccurrences > 0 && (
                        <View style={styles.aggregateStats}>
                          <Text style={styles.aggregateStatsTitle}>
                            📊 Resultados Consolidados (apenas avaliadores designados):
                          </Text>
                          <View style={styles.statsRow}>
                            <Text style={styles.statText}>
                              ✅ Conforme: {totalConforme} (
                              {Math.round((totalConforme / totalOccurrences) * 100)}%)
                            </Text>
                            <Text style={styles.statText}>
                              ❌ Não Conforme: {totalNaoConforme} (
                              {Math.round((totalNaoConforme / totalOccurrences) * 100)}%)
                            </Text>
                            <Text style={styles.statText}>
                              ➖ N/A: {totalNaoSeAplica} (
                              {Math.round((totalNaoSeAplica / totalOccurrences) * 100)}%)
                            </Text>
                          </View>
                        </View>
                      )}

                      {/* Detalhes do requisito */}
                      <View style={styles.requirementFullDetails}>
                        {group.requirement.premissa && (
                          <View style={styles.detailSection}>
                            <Text style={styles.detailLabel}>Premissa:</Text>
                            <Text style={styles.detailText}>{group.requirement.premissa}</Text>
                          </View>
                        )}

                        {group.requirement.fontes && (
                          <View style={styles.detailSection}>
                            <Text style={styles.detailLabel}>Fontes:</Text>
                            <Text style={styles.detailText}>{group.requirement.fontes}</Text>
                          </View>
                        )}

                        {group.requirement.segmento && (
                          <View style={styles.detailSection}>
                            <Text style={styles.detailLabel}>Segmento:</Text>
                            <Text style={styles.detailText}>{group.requirement.segmento}</Text>
                          </View>
                        )}
                      </View>

                      {/* Resumo por Avaliador */}
                      {Object.keys(evaluatorSummary).length > 0 && (
                        <View style={styles.requirementEvaluatorSection}>
                          <Text style={styles.requirementEvaluatorTitle}>
                            👥 Avaliações por Avaliador:
                          </Text>

                          {Object.values(evaluatorSummary).map((evaluator, index) => (
                            <View
                              key={evaluator.email || index}
                              style={styles.requirementEvaluatorCard}
                            >
                              <View style={styles.requirementEvaluatorHeader}>
                                <Text style={styles.requirementEvaluatorName}>
                                  {evaluator.nome}
                                </Text>
                                <Text style={styles.requirementEvaluatorEmail}>
                                  {evaluator.email}
                                </Text>
                              </View>

                              {evaluator.responses.map((resp, idx) => (
                                <View key={idx} style={styles.requirementEvaluatorResponse}>
                                  <Text style={styles.requirementEvaluatorFormTitle}>
                                    📋 {resp.formTitle}
                                  </Text>
                                  {resp.unitName && (
                                    <Text style={styles.requirementEvaluatorUnit}>
                                      🏢 {resp.unitName}
                                    </Text>
                                  )}
                                  <Text style={styles.requirementEvaluatorAnswer}>
                                    {getAnswerLabel(resp.answer)}
                                  </Text>
                                  {resp.finding && (
                                    <Text style={styles.requirementEvaluatorFinding}>
                                      💬 {resp.finding}
                                    </Text>
                                  )}
                                  {resp.attachments.length > 0 && (
                                    <Text style={styles.requirementEvaluatorAttachmentCount}>
                                      📎 {resp.attachments.length} anexo(s)
                                    </Text>
                                  )}
                                </View>
                              ))}
                            </View>
                          ))}
                        </View>
                      )}

                      {/* Todos os anexos deste requisito */}
                      {attachmentsByRequirement.length > 0 && (
                        <View style={styles.requirementAttachmentsSection}>
                          <Text style={styles.requirementAttachmentsTitle}>
                            📎 Todos os Anexos ({attachmentsByRequirement.length}):
                          </Text>

                          {attachmentsByRequirement.map((attachment, idx) => (
                            <TouchableOpacity
                              key={idx}
                              style={styles.requirementAttachmentItem}
                              onPress={() => handleOpenAttachment(attachment)}
                            >
                              <View style={styles.requirementAttachmentIcon}>
                                <Text style={styles.requirementAttachmentEmoji}>
                                  {getFileEmoji(attachment.mimeType, attachment.name)}
                                </Text>
                              </View>
                              <View style={styles.requirementAttachmentContent}>
                                <Text style={styles.requirementAttachmentName} numberOfLines={1}>
                                  {attachment.name || 'Anexo'}
                                </Text>
                                <Text style={styles.requirementAttachmentInfo}>
                                  📋 {attachment.formTitle} | 👤 {attachment.avaliadorNome}
                                </Text>
                                {attachment.unitName && (
                                  <Text style={styles.requirementAttachmentUnit}>
                                    🏢 {attachment.unitName}
                                  </Text>
                                )}
                                {attachment.description && (
                                  <Text
                                    style={styles.requirementAttachmentDescription}
                                    numberOfLines={2}
                                  >
                                    💬 {attachment.description}
                                  </Text>
                                )}
                                {attachment.validityDate && (
                                  <Text
                                    style={[
                                      styles.requirementAttachmentValidity,
                                      isExpired(attachment.validityDate) &&
                                        styles.attachmentValidityExpired,
                                      isNearExpiry(attachment.validityDate) &&
                                        styles.attachmentValidityWarning,
                                    ]}
                                  >
                                    📅 Válido até: {formatDate(attachment.validityDate)}
                                    {isExpired(attachment.validityDate) && ' (VENCIDO)'}
                                    {isNearExpiry(attachment.validityDate) &&
                                      !isExpired(attachment.validityDate) &&
                                      ' (PRÓX. VENCIMENTO)'}
                                  </Text>
                                )}
                              </View>
                              <MaterialCommunityIcons name="open-in-new" size={20} color="#666" />
                            </TouchableOpacity>
                          ))}
                        </View>
                      )}

                      {/* Lista de ocorrências em formulários */}
                      <View style={styles.occurrencesList}>
                        <Text style={styles.occurrencesTitle}>📋 Ocorrências em Formulários:</Text>
                        {group.forms.map(({ form, responses: formResponses }) => (
                          <View key={form.id} style={styles.occurrenceItem}>
                            <Text style={styles.occurrenceFormTitle}>{form.title}</Text>
                            {form.metadata?.unidadesOrganizacionais?.map(unit => (
                              <Text key={unit.id} style={styles.occurrenceUnit}>
                                • {unit.codigo} - {unit.nome}
                              </Text>
                            ))}
                            <View style={styles.occurrenceEvaluators}>
                              <Text style={styles.occurrenceEvaluatorLabel}>Avaliadores:</Text>
                              <Text style={styles.occurrenceEvaluatorName}>
                                1️⃣{' '}
                                {form.metadata?.avaliador1
                                  ? AVALIADORES.find(a => a.id === form.metadata.avaliador1)?.nome
                                  : 'Não designado'}
                              </Text>
                              <Text style={styles.occurrenceEvaluatorName}>
                                2️⃣{' '}
                                {form.metadata?.avaliador2
                                  ? AVALIADORES.find(a => a.id === form.metadata.avaliador2)?.nome
                                  : 'Não designado'}
                              </Text>
                            </View>
                          </View>
                        ))}
                      </View>
                    </>
                  )}
                </Card.Content>
              </TouchableOpacity>
            </Card>
          );
        })}

        {sortedRequirements.length === 0 && (
          <Card style={styles.emptyCard}>
            <Card.Content>
              <View style={styles.emptyContent}>
                <MaterialCommunityIcons name="format-list-checks" size={48} color="#999" />
                <Text style={styles.emptyText}>Nenhum requisito encontrado</Text>
              </View>
            </Card.Content>
          </Card>
        )}
      </ScrollView>
    );
  };

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return renderByForm();
      case 1:
        return renderByProcess();
      case 2:
        return renderByRequirement();
      case 3:
        return renderByUnit();
      default:
        return renderByForm();
    }
  };

  if (loading) {
    return (
      <View style={styles.container}>
        <Appbar.Header style={styles.appbar}>
          <Appbar.BackAction onPress={onBack} color={AVAQualisTheme.colors.onPrimary} />
          <Appbar.Content title="Resultados Consolidados" titleStyle={styles.appbarTitle} />
        </Appbar.Header>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color={AVAQualisTheme.colors.primary} />
          <Text style={styles.loadingText}>Carregando resultados...</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Appbar.Header style={styles.appbar}>
        <Appbar.BackAction onPress={onBack} color={AVAQualisTheme.colors.onPrimary} />
        <Appbar.Content
          title="Resultados Consolidados"
          subtitle={`${forms.length} roteiros • ${responses.length} respostas`}
          titleStyle={styles.appbarTitle}
          subtitleStyle={styles.appbarSubtitle}
        />
        <Appbar.Action
          icon="download"
          onPress={downloadBackup}
          color={AVAQualisTheme.colors.onPrimary}
          disabled={downloadingBackup}
        />
        <Menu
          visible={filterMenuVisible}
          onDismiss={() => setFilterMenuVisible(false)}
          anchor={
            <Appbar.Action
              icon="filter"
              onPress={() => setFilterMenuVisible(true)}
              color={AVAQualisTheme.colors.onPrimary}
            />
          }
        >
          <Menu.Item
            onPress={() => {
              setSelectedFilter('all');
              setFilterMenuVisible(false);
            }}
            title="Todos"
            leadingIcon={selectedFilter === 'all' ? 'check' : undefined}
          />
          <Menu.Item
            onPress={() => {
              setSelectedFilter('complete');
              setFilterMenuVisible(false);
            }}
            title="Completos"
            leadingIcon={selectedFilter === 'complete' ? 'check' : undefined}
          />
          <Menu.Item
            onPress={() => {
              setSelectedFilter('incomplete');
              setFilterMenuVisible(false);
            }}
            title="Incompletos"
            leadingIcon={selectedFilter === 'incomplete' ? 'check' : undefined}
          />
          <Menu.Item
            onPress={() => {
              setSelectedFilter('no-responses');
              setFilterMenuVisible(false);
            }}
            title="Sem Respostas"
            leadingIcon={selectedFilter === 'no-responses' ? 'check' : undefined}
          />
        </Menu>
        <Appbar.Action icon="refresh" onPress={onRefresh} color={AVAQualisTheme.colors.onPrimary} />
      </Appbar.Header>

      {/* Botão de Backup */}
      <TouchableOpacity
        style={styles.backupButton}
        onPress={downloadBackup}
        disabled={downloadingBackup}
      >
        <MaterialCommunityIcons name="database-export" size={24} color="#FFFFFF" />
        <Text style={styles.backupButtonText}>
          {downloadingBackup
            ? 'Gerando backup...'
            : 'Clique aqui para fazer backup de todas as respostas'}
        </Text>
        {downloadingBackup && (
          <ActivityIndicator size="small" color="#FFFFFF" style={{ marginLeft: 8 }} />
        )}
      </TouchableOpacity>

      {/* Barra de Pesquisa */}
      <Searchbar
        placeholder="Pesquisar roteiros..."
        onChangeText={setSearchQuery}
        value={searchQuery}
        style={styles.searchBar}
        iconColor={AVAQualisTheme.colors.primary}
      />

      {/* Tabs de Visualização */}
      {/* Tabs de Visualização */}
      <View style={styles.tabContainer}>
        <TouchableOpacity
          style={[styles.tab, activeTab === 0 && styles.activeTab]}
          onPress={() => setActiveTab(0)}
        >
          <MaterialCommunityIcons
            name="file-document-multiple"
            size={20}
            color={activeTab === 0 ? AVAQualisTheme.colors.primary : '#666'}
          />
          <Text style={[styles.tabText, activeTab === 0 && styles.activeTabText]}>Por Roteiro</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.tab, activeTab === 1 && styles.activeTab]}
          onPress={() => setActiveTab(1)}
        >
          <MaterialCommunityIcons
            name="cog-outline"
            size={20}
            color={activeTab === 1 ? AVAQualisTheme.colors.primary : '#666'}
          />
          <Text style={[styles.tabText, activeTab === 1 && styles.activeTabText]}>
            Por Processo
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.tab, activeTab === 2 && styles.activeTab]}
          onPress={() => setActiveTab(2)}
        >
          <MaterialCommunityIcons
            name="format-list-checks"
            size={20}
            color={activeTab === 2 ? AVAQualisTheme.colors.primary : '#666'}
          />
          <Text style={[styles.tabText, activeTab === 2 && styles.activeTabText]}>
            Por Requisito
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.tab, activeTab === 3 && styles.activeTab]}
          onPress={() => setActiveTab(3)}
        >
          <MaterialCommunityIcons
            name="office-building"
            size={20}
            color={activeTab === 3 ? AVAQualisTheme.colors.primary : '#666'}
          />
          <Text style={[styles.tabText, activeTab === 3 && styles.activeTabText]}>Por Unidade</Text>
        </TouchableOpacity>
      </View>

      {/* Conteúdo Principal */}
      <View style={styles.content}>{renderContent()}</View>

      {/* Dialog */}
      <CustomDialog
        visible={dialogVisible}
        onDismiss={() => setDialogVisible(false)}
        title={dialogContent.title}
        message={dialogContent.message}
        actions={dialogContent.actions}
      />

      {/* Modal para visualizar respostas não autorizadas */}
      <UnauthorizedEvaluatorModal
        visible={unauthorizedEvaluatorModalVisible}
        onDismiss={() => {
          setUnauthorizedEvaluatorModalVisible(false);
          setSelectedUnauthorizedEvaluator(null);
          setSelectedUnauthorizedResponses([]);
          setSelectedUnauthorizedForm(null);
        }}
        evaluator={selectedUnauthorizedEvaluator}
        responses={selectedUnauthorizedResponses}
        form={selectedUnauthorizedForm}
      />

      {/* Loading overlay para operações de exclusão */}
      {deletingForm && (
        <Modal visible={true} transparent={true}>
          <View style={styles.loadingOverlay}>
            <View style={styles.loadingModal}>
              <ActivityIndicator size="large" color={AVAQualisTheme.colors.primary} />
              <Text style={styles.loadingModalText}>Excluindo...</Text>
            </View>
          </View>
        </Modal>
      )}

      {/* Modal de Opções de Exclusão */}
      <DeleteOptionsModal
        visible={deleteOptionsModalVisible}
        onDismiss={() => {
          setDeleteOptionsModalVisible(false);
          setSelectedFormToDelete(null);
        }}
        form={selectedFormToDelete}
        responses={
          selectedFormToDelete ? responses.filter(r => r.formId === selectedFormToDelete.id) : []
        }
        onDeleteForm={confirmDeleteForm}
        onDeleteEvaluator={evaluator => {
          console.log('🟢 onDeleteEvaluator chamado para:', evaluator.nome);

          // Guardar o avaliador selecionado
          setSelectedEvaluatorToDelete(evaluator);

          // NÃO fechar o modal de opções ainda
          // Abrir o modal de confirmação de exclusão do avaliador
          setDeleteEvaluatorModalVisible(true);
        }}
      />
      {/* Modal de Confirmação de Exclusão de Avaliador */}
      <DeleteEvaluatorModal
        visible={deleteEvaluatorModalVisible}
        onDismiss={() => {
          setDeleteEvaluatorModalVisible(false);
          setSelectedEvaluatorToDelete(null);
        }}
        form={selectedFormToDelete}
        evaluator={selectedEvaluatorToDelete}
        onConfirm={() => {
          if (selectedFormToDelete && selectedEvaluatorToDelete) {
            // Fechar ambos os modais
            setDeleteEvaluatorModalVisible(false);
            setDeleteOptionsModalVisible(false);

            // Executar a exclusão
            deleteEvaluatorResponses(selectedEvaluatorToDelete, selectedFormToDelete);

            // Limpar estados
            setSelectedEvaluatorToDelete(null);
          }
        }}
      />
      {/* Modal de Confirmação de Exclusão Completa */}
      <DeleteFormModal
        visible={deleteFormModalVisible}
        onDismiss={() => {
          setDeleteFormModalVisible(false);
          // NÃO fechar o selectedFormToDelete aqui
        }}
        form={selectedFormToDelete}
        onConfirm={() => {
          if (selectedFormToDelete) {
            // Fechar o modal de opções também
            setDeleteOptionsModalVisible(false);
            deleteFormComplete(selectedFormToDelete);
          }
        }}
      />
    </View>
  );
}
